var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { f as ref, g as watch, d as defineComponent, h as useLocale, i as usePassage, j as computed, k as onMounted, l as le, m as onBeforeUnmount, c as createElementBlock, w as withDirectives, v as vShow, a as createBaseVNode, p as createTextVNode, t as toDisplayString, u as unref, q as withModifiers, n as normalizeClass, x as vModelText, r as renderSlot, y as normalizeStyle, z as createCommentVNode, _ as _export_sfc, o as openBlock, A as pushScopeId, B as popScopeId, C as re, D as readonly, W, U as UAParser, b as createBlock, e as withCtx, E as createVNode, F as p, I as Icons, G as InlineSvg, H as useTheme, T as Theme, R, J as renderList, K as Fragment, L as isRef, M as useDefaultCountryCode, N as Transition, O as q, P as normalizeProps, Q as guardReactiveProps, S as vModelDynamic, V as useAddDevice, X as reactive, Y as me, Z as Dropdown, $ as useAppInfo, a0 as onUpdated, a1 as mergeProps, a2 as resolveDynamicComponent, a3 as onBeforeUpdate, a4 as useStoreLocale, a5 as useThemeSetup, a6 as useIntlTelInput, a7 as createPassageInstance } from "./customElements.es.js";
import { i as intlTelInput, t as transformMetadata, L as LayoutType, U as UserMetadata, s as socialConnectionMetadata, C as Checkbox } from "./customElements.es3.js";
function isStringNullish(value) {
  return value === void 0 || value === null || value === "" || value === " ";
}
var IdentifierType = /* @__PURE__ */ ((IdentifierType2) => {
  IdentifierType2["phone"] = "PHONE";
  IdentifierType2["email"] = "EMAIL";
  return IdentifierType2;
})(IdentifierType || {});
function useAutofocusButton() {
  const autofocusButton = ref();
  function autofocus() {
    if (autofocusButton.value === void 0 || autofocusButton.value === null) {
      return;
    }
    autofocusButton.value.focus();
  }
  watch(autofocusButton, () => {
    autofocus();
  });
  return {
    autofocusButton
  };
}
function inputStyles() {
  const css = `
      .psg-input{
        -webkit-appearance: none;
        -moz-appearance: none;
        box-sizing: border-box;
        color: var(--passage-input-text-color, var(--passage-body-text-color-default));
        font-family: var(--passage-body-font-family, var(--passage-body-font-family-default));
        font-size: var(--passage-body-font-size, var(--passage-body-font-size-default));
        font-weight: var(--passage-body-font-weight, var(--passage-body-font-weight-default));

        min-height: 40px;
        width: 100%;

        padding-left: 10px;
        padding-right: 10px;
        margin: 0;

        background-color: var(--passage-input-box-background-color, var(--passage-input-box-background-color-default));
        border-style: solid;
        border-color: var(--passage-control-border-color, var(--passage-control-border-color-default));
        border-width: 1px;
        border-radius: var(--passage-input-box-border-radius, var(--passage-input-box-border-radius-default));

        transition: all 0.3s;

        text-overflow: ellipsis;
      }

      .psg-input:hover {
        border-color: var(--passage-control-border-hover-color, var(--passage-control-border-hover-color-default));
      }

      .psg-input:focus{
        outline: none;
        box-shadow: none !important;
        border-color: var(--passage-control-border-active-color, var(--passage-control-border-active-color-default));
      }

      .psg-input:active{
        outline: none;
        box-shadow: none !important;
        border-color: var(--passage-control-border-active-color, var(--passage-control-border-active-color-default));
      }

      .psg-input.has-error{
        border-color: var(--passage-error-color, var(--passage-error-color-default));
      }
      .psg-input.is-danger{
        border-color: var(--passage-error-color, var(--passage-error-color-default));
      }
      .iti {
        width: 100%;
      }

        .iti__country-list {
            border-radius: 6px;
        }

        .iti__country {
            padding: 5px 10px;
        }

        .iti__selected-flag {
            border-top-left-radius: var(--passage-control-border-radius, var(--passage-input-box-border-radius-default));
            border-bottom-left-radius: var(--passage-control-border-radius, var(--passage-input-box-border-radius-default));
        }

    .iti--container {
        top: unset !important;
        left: unset !important;
    }`;
  const style = document.createElement("style");
  style.appendChild(document.createTextNode(css));
  return style;
}
function itiStyles() {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/css/intlTelInput.css";
  return link;
}
function otcStyles() {
  const css = `
      .psg-otp-input-container{
        margin: 0px;
        padding: 0px;
        align-items: center;
        height: auto;
        width: auto;
      }
      .psg-otp-single-input-container{
        margin: 0px;
        padding: 0px;
        height: auto;
        width: auto;
      }
      .psg-otp-input {
        width: 40px;
        height: 40px;
        padding: 0px;
        margin-left: 4px;
        margin-right: 4px;
        font-size: 24px;
        font-weight: 400;
        color: var(--passage-input-text-color, var(--passage-body-text-color-default));
        font-family: var(--passage-body-font-family, var(--passage-body-font-family-default));
        line-height: 29px;
        border-radius: 4px;
        border: 1px solid var(--passage-control-border-color, var(--passage-control-border-color-default));
        text-align: center;
            background-color: var(
                --passage-otp-input-background-color,
                var(--passage-input-box-background-color, var(--passage-input-box-background-color-default))
            );
        -moz-appearance: textfield;
      }
      .psg-otp-input:read-only {
            background-color: var(
                --passage-otp-input-background-color,
                var(--passage-input-box-background-color, var(--passage-input-box-background-color-default))
            );
      }
      .psg-otp-input::-webkit-inner-spin-button{
        -webkit-appearance: none;
        display: none;
        margin: 0;
      }
      .psg-otp-input::-webkit-outer-spin-button{
        -webkit-appearance: none;
        display: none;
        margin: 0;
      }
      .psg-input.has-error{
        border-color: var(--passage-error-color, var(--passage-error-color-default)) !important;
      }
      .psg-input.is-danger {
        border-color: var(--passage-error-color, var(--passage-error-color-default)) !important;
      }
      .psg-input:focus {
        outline: none;
        box-shadow: none !important;
        border-color: var(--passage-control-border-active-color, var(--passage-control-border-active-color-default));
      }
      .psg-input:active {
        outline: none;
        box-shadow: none !important;
        border-color: var(--passage-control-border-active-color, var(--passage-control-border-active-color-default));
      }`;
  const style = document.createElement("style");
  style.appendChild(document.createTextNode(css));
  return style;
}
var ValidatedIdentifierForm_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId = (n) => (pushScopeId("data-v-a9054ff0"), n = n(), popScopeId(), n);
const _hoisted_1$w = { class: "identifier-form" };
const _hoisted_2$l = { class: "has-text-centered" };
const _hoisted_3$i = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createBaseVNode("br", null, null, -1));
const _hoisted_4$g = { class: "identifier-text" };
const _hoisted_5$f = ["onSubmit"];
const _hoisted_6$d = ["autocomplete", "inputmode", "placeholder", "onInput"];
const _hoisted_7$c = { class: "flex-row flex-center" };
const _hoisted_8$a = ["onClick"];
const _hoisted_9$a = {
  key: 0,
  style: { "margin-top": "30px" },
  class: "link has-text-centered"
};
const _hoisted_10$7 = ["onClick"];
const _sfc_main$A = defineComponent({
  __name: "ValidatedIdentifierForm",
  props: {
    validationError: { default: "" },
    identifier: {},
    countryCode: {},
    identifierMode: {},
    showWelcomeBack: { type: Boolean, default: false },
    conditionalUI: { type: Boolean, default: false }
  },
  emits: [
    "onSubmit",
    "update:validationError",
    "update:identifier",
    "update:countryCode",
    "update:showWelcomeBack"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const { t } = useLocale();
    const identifierParseError = ref("");
    const identifierInput = ref();
    const controlContainer = ref();
    const { autofocusButton } = useAutofocusButton();
    const { passage } = usePassage();
    const showWelcomeUI = computed(() => {
      return props.showWelcomeBack;
    });
    const label = computed(() => {
      let identifierType;
      switch (props.identifierMode) {
        case le.phone:
          identifierType = t("phone-number");
          break;
        case le.email:
          identifierType = t("email-address");
          break;
        case le.both:
          identifierType = t("email-or-phone-number");
          break;
      }
      return identifierType.charAt(0).toUpperCase() + identifierType.slice(1);
    });
    const placeholder = computed(() => {
      return "example@email.com";
    });
    const inputMode = computed(() => {
      if (props.identifierMode === le.phone) {
        return "tel";
      }
      return "email";
    });
    const autocomplete = computed(() => {
      var _a;
      if (props.conditionalUI) {
        return `${inputMode.value} webauthn`;
      }
      return (_a = inputMode.value) != null ? _a : "";
    });
    const identifierText = computed({
      get() {
        return props.identifier;
      },
      set(newIdentifier) {
        emit("update:identifier", newIdentifier);
      }
    });
    function formattedIdentifier() {
      var _a;
      if (!identifierText.value) {
        return "";
      }
      let identifier2 = identifierText.value;
      if (!showWelcomeUI.value) {
        identifier2 = isPhoneNumber() ? (_a = phoneInput == null ? void 0 : phoneInput.getNumber()) != null ? _a : "" : identifierText.value;
      }
      return identifier2.trim().toLowerCase();
    }
    const error = computed(() => {
      if (!isStringNullish(props.validationError)) {
        return props.validationError;
      }
      if (!isStringNullish(identifierParseError.value)) {
        return identifierParseError.value;
      }
      return "";
    });
    function clearErrors() {
      identifierParseError.value = "";
      emit("update:validationError", "");
    }
    function checkIdentifier() {
      return __async(this, null, function* () {
        if (!validateInput()) {
          return;
        }
        let identifierExists, emailVerified, phoneVerified = false;
        let webauthnTypes = [];
        let userStatus;
        let userID = "";
        try {
          const userInfo = yield passage.identifierExists(formattedIdentifier());
          if (userInfo !== null) {
            identifierExists = true;
            userStatus = userInfo.status;
            userID = userInfo.id;
            emailVerified = userInfo.email_verified;
            phoneVerified = userInfo.phone_verified;
            webauthnTypes = userInfo.webauthn_types;
          } else {
            identifierExists = false;
            userStatus = re.INACTIVE;
          }
        } catch (e) {
          let errorMessage;
          switch (props.identifierMode) {
            case le.email:
              errorMessage = t("enter-a-valid-email-address");
              break;
            case le.phone:
              errorMessage = t("enter-a-valid-phone-number");
              break;
            case le.both:
              errorMessage = t("enter-a-valid-email-or-phone-number");
              break;
          }
          identifierParseError.value = errorMessage;
          return;
        }
        emit("onSubmit", {
          identifier: formattedIdentifier(),
          identifierExists,
          identifierType: isPhoneNumber() ? IdentifierType.phone : IdentifierType.email,
          userStatus,
          userID,
          emailVerified,
          phoneVerified,
          webauthnTypes
        });
      });
    }
    function isEmail() {
      const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegEx.test(formattedIdentifier());
    }
    function isPhoneNumber() {
      if (showWelcomeUI.value) {
        return isPhoneNumberRegex();
      }
      if (phoneInput === void 0) {
        return false;
      }
      return phoneInput.isValidNumber();
    }
    function validateInput() {
      if (formattedIdentifier() === "") {
        let message = "";
        switch (props.identifierMode) {
          case le.phone:
            message = t("enter-a-phone-number");
            break;
          case le.email:
            message = t("enter-an-email-address");
            break;
          case le.both:
            message = t("enter-an-email-or-phone-number");
            break;
        }
        identifierParseError.value = message;
        return false;
      } else if (props.identifierMode === le.email && !isEmail()) {
        identifierParseError.value = t("enter-a-valid-email-address");
        return false;
      } else if (props.identifierMode === le.phone && !isPhoneNumber()) {
        identifierParseError.value = t("enter-a-valid-phone-number");
        return false;
      } else if (props.identifierMode === le.both && !isPhoneNumber() && !isEmail()) {
        identifierParseError.value = t("enter-a-valid-email-or-phone-number");
        return false;
      }
      return true;
    }
    let phoneInput;
    function showCountryCode() {
      if (phoneInput !== void 0) {
        return;
      }
      identifierInput.value.addEventListener("countrychange", () => {
        var _a;
        emit("update:countryCode", (_a = phoneInput == null ? void 0 : phoneInput.getSelectedCountryData().iso2) != null ? _a : "");
      });
      phoneInput = intlTelInput(identifierInput.value, {
        initialCountry: props.countryCode,
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
        dropdownContainer: controlContainer.value,
        autoPlaceholder: "aggressive"
      });
      identifierInput.value.focus();
    }
    function hideCountryCode() {
      if (phoneInput === void 0) {
        return;
      }
      phoneInput.destroy();
      phoneInput = void 0;
      if (identifierInput.value) {
        identifierInput.value.focus();
      }
    }
    onMounted(() => {
      if (props.conditionalUI) {
        moveInput();
      }
      if (props.identifierMode === le.phone) {
        showCountryCode();
      }
    });
    function isPhoneNumberRegex() {
      const phoneNumberRegex = /^\+$|^\+?[0-9,(,),\-, ]+$/;
      return phoneNumberRegex.test(identifierText.value.trim());
    }
    if (props.identifierMode === le.both) {
      watch(identifierText, () => {
        if (isPhoneNumberRegex()) {
          showCountryCode();
        } else {
          hideCountryCode();
        }
      });
    }
    const countryCodeText = computed(() => {
      return props.countryCode;
    });
    watch(countryCodeText, (newValue) => {
      phoneInput == null ? void 0 : phoneInput.setCountry(newValue);
    });
    function switchAccount() {
      emit("update:showWelcomeBack", false);
      identifierText.value = "";
    }
    const identifierForm = ref();
    function moveInput() {
      const parent = identifierForm.value.getRootNode().host;
      if (parent !== void 0) {
        identifierForm.value.appendChild(inputStyles());
        identifierForm.value.appendChild(itiStyles());
        parent.appendChild(identifierForm.value);
      }
    }
    function cleanupInput() {
      identifierForm.value.remove();
    }
    onBeforeUnmount(() => {
      cleanupInput();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$w, [
        withDirectives(createBaseVNode("div", _hoisted_2$l, [
          createTextVNode(toDisplayString(unref(t)("welcome-back-sign-in-as")), 1),
          _hoisted_3$i,
          createBaseVNode("strong", _hoisted_4$g, toDisplayString(identifierText.value), 1)
        ], 512), [
          [vShow, _ctx.showWelcomeBack]
        ]),
        withDirectives(createBaseVNode("div", null, [
          createBaseVNode("div", {
            class: "label",
            ref: "labelRef"
          }, toDisplayString(label.value), 513),
          createBaseVNode("form", {
            ref_key: "identifierForm",
            ref: identifierForm,
            slot: "loginInput",
            onSubmit: withModifiers(checkIdentifier, ["prevent"])
          }, [
            withDirectives(createBaseVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => identifierText.value = $event),
              type: "text",
              class: normalizeClass(["input psg-input", { "is-danger": error.value }]),
              part: "input",
              autocomplete: autocomplete.value,
              inputmode: inputMode.value,
              id: "identifier",
              placeholder: placeholder.value,
              onInput: withModifiers(clearErrors, ["prevent"]),
              "data-testid": "identifier-input",
              ref_key: "identifierInput",
              ref: identifierInput
            }, null, 42, _hoisted_6$d), [
              [vModelText, identifierText.value]
            ])
          ], 40, _hoisted_5$f),
          renderSlot(_ctx.$slots, "loginInput", {}, void 0, true)
        ], 512), [
          [vShow, !_ctx.showWelcomeBack]
        ]),
        createBaseVNode("div", {
          ref_key: "controlContainer",
          ref: controlContainer,
          style: { "width": "100%" }
        }, null, 512),
        createBaseVNode("div", {
          style: normalizeStyle([`text-align: ${showWelcomeUI.value ? "center" : "left"};`, { "height": "32px" }]),
          class: "help is-danger error-message",
          "data-testid": "validation-error"
        }, toDisplayString(error.value), 5),
        renderSlot(_ctx.$slots, "metadataFields", {}, void 0, true),
        createBaseVNode("div", _hoisted_7$c, [
          createBaseVNode("button", {
            class: "button is-primary",
            part: "button",
            "data-testid": "continue-button",
            ref_key: "autofocusButton",
            ref: autofocusButton,
            onClick: withModifiers(checkIdentifier, ["prevent"])
          }, toDisplayString(unref(t)("continue")), 9, _hoisted_8$a)
        ]),
        showWelcomeUI.value ? (openBlock(), createElementBlock("div", _hoisted_9$a, [
          createBaseVNode("a", {
            onClick: withModifiers(switchAccount, ["prevent"]),
            role: "button",
            class: "body-link",
            "data-testid": "register-link"
          }, toDisplayString(unref(t)("switch-account")), 9, _hoisted_10$7)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
var ValidatedIdentifierForm = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["__scopeId", "data-v-a9054ff0"]]);
var OnEventType = /* @__PURE__ */ ((OnEventType2) => {
  OnEventType2["onLoaded"] = "onLoaded";
  OnEventType2["onRegisterDevice"] = "onRegisterDevice";
  OnEventType2["onVerifyIdentity"] = "onVerifyIdentity";
  OnEventType2["onMagicLinkLogin"] = "onMagicLinkLogin";
  OnEventType2["onMagicLinkRegister"] = "onMagicLinkRegister";
  OnEventType2["onMagicLinkActivated"] = "onMagicLinkActivated";
  OnEventType2["onMagicLinkActivateSuccess"] = "onMagicLinkActivateSuccess";
  OnEventType2["onOneTimePasscodeLogin"] = "onOneTimePasscodeLogin";
  OnEventType2["onOneTimePasscodeRegister"] = "onOneTimePasscodeRegister";
  OnEventType2["onOneTimePasscodeActivated"] = "onOneTimePasscodeActivated";
  OnEventType2["onOneTimePasscodeActivateSuccess"] = "onOneTimePasscodeActivateSuccess";
  return OnEventType2;
})(OnEventType || {});
var BeforeAuthCallbackType = /* @__PURE__ */ ((BeforeAuthCallbackType2) => {
  BeforeAuthCallbackType2["Login"] = "login";
  BeforeAuthCallbackType2["Register"] = "register";
  return BeforeAuthCallbackType2;
})(BeforeAuthCallbackType || {});
const defaultBeforeAuth = () => {
  return true;
};
const defaultOnSuccess = (authResult2) => {
  window.location.href = authResult2.redirect_url;
};
const defaultOnEvent = () => {
  return;
};
const beforeAuth = ref(defaultBeforeAuth);
const onSuccess = ref(defaultOnSuccess);
const onEvent = ref(defaultOnEvent);
function setBeforeAuth(newBeforeAuth) {
  if (newBeforeAuth === void 0) {
    beforeAuth.value = defaultBeforeAuth;
    return;
  }
  beforeAuth.value = newBeforeAuth;
}
function setOnSuccess(newOnSuccess) {
  if (newOnSuccess === void 0) {
    onSuccess.value = defaultOnSuccess;
    return;
  }
  onSuccess.value = newOnSuccess;
}
function setOnEvent(newOnEvent) {
  if (newOnEvent === void 0) {
    onEvent.value = defaultOnEvent;
    return;
  }
  onEvent.value = newOnEvent;
}
function useCallbacks() {
  return {
    beforeAuth: readonly(beforeAuth),
    onSuccess: readonly(onSuccess),
    onEvent: readonly(onEvent),
    setBeforeAuth,
    setOnSuccess,
    setOnEvent
  };
}
const storageKey = "psg_last_login";
function getLastLogin() {
  return localStorage.getItem(storageKey);
}
function storeLastLogin(appInfo, passage, identiferOrUserInfo) {
  return __async(this, null, function* () {
    if (identiferOrUserInfo && typeof identiferOrUserInfo === "string") {
      localStorage.setItem(storageKey, identiferOrUserInfo);
      return;
    }
    let currentInfo = identiferOrUserInfo;
    if (identiferOrUserInfo === void 0) {
      try {
        currentInfo = yield passage.getCurrentUser().userInfo();
      } catch (err) {
        console.error("Failed to fetch current user, auth token likely missing or invalid", err);
      }
    }
    if (currentInfo === void 0) {
      return;
    }
    let identifierToStore = "";
    switch (appInfo.allowed_identifier) {
      case le.email:
        identifierToStore = currentInfo.email;
        break;
      case le.phone:
        identifierToStore = currentInfo.phone;
        break;
      case le.both:
        identifierToStore = currentInfo.email ? currentInfo.email : currentInfo.phone;
        break;
    }
    localStorage.setItem(storageKey, identifierToStore);
  });
}
function createdUserEventHandler(payload, eventHandlerState) {
  const { appInfo, router, passkeyFeatures } = eventHandlerState;
  const { identifier: identifier2, identifierType } = payload;
  const { emitEvent: emitEvent2 } = useAuthEvent();
  if (!passkeyFeatures.securityKey || appInfo.require_identifier_verification) {
    emitEvent2({
      type: AuthEventType.EmailOrSMSAuth,
      payload: {
        identifier: identifier2,
        identifierType,
        identifierVerifying: appInfo.require_identifier_verification,
        userIsRegistering: true,
        userInitiated: false
      }
    });
    return;
  }
  useCallbacks().onEvent.value(OnEventType.onRegisterDevice, { identifier: identifier2 });
  router.push(RegisterDeviceRoute, { identifier: identifier2, identifierType, appInfo, passkeyFeatures });
}
function changeIdenfitierEventHandler(eventHandlerState) {
  const { appInfo, router, passkeyFeatures } = eventHandlerState;
  cleanQueryParams();
  router.push(router.homeRoute, { appInfo, conditionalUI: passkeyFeatures.conditionalUI, changeEmail: true });
}
function cleanQueryParams() {
  const params = new URLSearchParams(window.location.search);
  params.delete("code");
  params.delete("link_account");
  params.delete("provider_identifier");
  params.delete("state");
  let url = window.location.pathname;
  if (params.size !== 0) {
    url += `?${params.toString()}`;
  }
  window.history.pushState({}, document.title, url);
}
function isWebauthnGetMonkeypatched() {
  const isGetNative = navigator.credentials.get.toString().includes("[native code]");
  return !isGetNative;
}
var EmailOrSMS = /* @__PURE__ */ ((EmailOrSMS2) => {
  EmailOrSMS2["Email"] = "email";
  EmailOrSMS2["SMS"] = "sms";
  EmailOrSMS2["None"] = "none";
  return EmailOrSMS2;
})(EmailOrSMS || {});
function emailOrSMS(appInfo) {
  if (appInfo.auth_methods.otp) {
    return "sms";
  }
  if (appInfo.auth_methods.magic_link) {
    return "email";
  }
  return "none";
}
function loginUserEventHandler(payload, eventHandlerState, passage) {
  return __async(this, null, function* () {
    var _a, _b;
    eventHandlerState.authState.linkingAccount = (_a = payload.linkingAccount) != null ? _a : false;
    eventHandlerState.authState.socialLogin = (_b = payload.linkingAccount) != null ? _b : false;
    const { passkeyFeatures, appInfo, router } = eventHandlerState;
    const { emitEvent: emitEvent2 } = useAuthEvent();
    const { identifier: identifier2, identifierType, webauthnTypes, emailVerified, phoneVerified, userID } = payload;
    const passkeysOnly = emailOrSMS(appInfo) === EmailOrSMS.None;
    if (webauthnTypes.length === 0 && passkeysOnly) {
      router.push(LoginNotSupportedRoute);
      return;
    }
    const userHasPasskey = webauthnTypes.includes(W.Passkey);
    const userHasPlatform = webauthnTypes.includes(W.Platform);
    const userHasSecurityKey = webauthnTypes.includes(W.SecurityKey);
    const verificationRequired = userNeedsToVerify(appInfo, emailVerified, phoneVerified, identifierType);
    const canTryPlaform = passkeyFeatures.platform && userHasPlatform && passage.credIDExists(userID);
    const canTryPasskey = (passkeyFeatures.syncedCredential || passkeyFeatures.crossDeviceCredential) && userHasPasskey;
    const canTrySecurityKey = passkeyFeatures.securityKey && userHasSecurityKey;
    const tryWebauthnWithNoFallback = passkeyFeatures.platform && passkeysOnly;
    const tryNonNativeWebauthn = userHasPasskey && passkeyFeatures.platform && isWebauthnGetMonkeypatched();
    const canTryWebAuthn = !verificationRequired && (canTryPasskey || canTryPlaform || canTrySecurityKey || tryWebauthnWithNoFallback || tryNonNativeWebauthn);
    if (canTryWebAuthn) {
      useCallbacks().onEvent.value(OnEventType.onVerifyIdentity);
      router.push(WebauthnSignInRoute, {
        identifier: identifier2,
        identifierType,
        appInfo,
        userIsVerifying: payload.linkingAccount
      });
    } else {
      emitEvent2({
        type: AuthEventType.EmailOrSMSAuth,
        payload: {
          identifier: identifier2,
          identifierType,
          userInitiated: false,
          identifierVerifying: verificationRequired || payload.linkingAccount,
          setupNewDevice: passkeyFeatures.platform
        }
      });
    }
  });
}
function userNeedsToVerify(appInfo, emailVerified, phoneVerified, identifierType) {
  if (appInfo.require_identifier_verification) {
    if (identifierType === IdentifierType.email && !emailVerified || identifierType === IdentifierType.phone && !phoneVerified) {
      return true;
    }
  }
  return false;
}
function emailOrSMSAuthEventHandler(payload, eventHandlerState) {
  const { authState, appInfo, router } = eventHandlerState;
  authState.userInitiatedFallback = payload.userInitiated;
  switch (emailOrSMS(appInfo)) {
    case EmailOrSMS.SMS:
      otpCallback(payload);
      router.push(OneTimePasscodeRoute, payload);
      break;
    case EmailOrSMS.Email:
      magicLinkCallback(payload);
      router.push(MagicLinkRoute, payload);
      break;
    case EmailOrSMS.None:
      router.push(DisableFallbacksRoute);
      break;
  }
}
function magicLinkCallback(payload) {
  const { identifier: identifier2, userIsRegistering } = payload;
  if (userIsRegistering) {
    useCallbacks().onEvent.value(OnEventType.onMagicLinkRegister, { identifier: identifier2 });
  } else {
    useCallbacks().onEvent.value(OnEventType.onMagicLinkLogin);
  }
}
function otpCallback(payload) {
  const { identifier: identifier2, userIsRegistering } = payload;
  if (userIsRegistering) {
    useCallbacks().onEvent.value(OnEventType.onOneTimePasscodeRegister, { identifier: identifier2 });
  } else {
    useCallbacks().onEvent.value(OnEventType.onOneTimePasscodeLogin);
  }
}
function authSuccessEventHandler(payload, eventHandlerState, passage) {
  return __async(this, null, function* () {
    if (isStringNullish(payload.authResult.auth_token) || isStringNullish(payload.authResult.redirect_url)) {
      return;
    }
    const { socialLogin, linkingAccount } = eventHandlerState.authState;
    if (linkingAccount) {
      yield finishLinkingAccount(passage);
    }
    if (!socialLogin) {
      yield storeLastLogin(eventHandlerState.appInfo, passage, payload.identifier);
    }
    useCallbacks().onSuccess.value(payload.authResult);
  });
}
function finishLinkingAccount(passage) {
  return __async(this, null, function* () {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const code = urlParams.get("code");
    if (code === null || code === "" || code === " ") {
      console.error("Failed to link social account to existing account");
      return;
    }
    yield passage.getCurrentUser().linkSocialAccount(code);
  });
}
function emailOrSMSAuthSuccessEventHandler(payload, eventHandlerState) {
  const { webauthnAllowed, authState, router } = eventHandlerState;
  if (webauthnAllowed && !authState.userInitiatedFallback && !authState.linkingAccount) {
    router.push(AddDeviceRoute, payload);
    return;
  }
  useAuthEvent().emitEvent({
    type: AuthEventType.AuthSuccess,
    payload
  });
}
function isSafariVersionLessThan164() {
  var _a;
  const userAgent = new UAParser();
  return ((_a = userAgent.getBrowser().name) == null ? void 0 : _a.toLowerCase().includes("safari")) && parseFloat(userAgent.getBrowser().version || "") < 16.4;
}
function socialAuthEventHandler(eventHandlerState, passage) {
  return __async(this, null, function* () {
    const { emitEvent: emitEvent2 } = useAuthEvent();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const code = urlParams.get("code");
    const linkAccount = urlParams.get("link_account");
    const identifier2 = urlParams.get("provider_identifier");
    if (code === null || linkAccount === null || identifier2 === null) {
      emitEvent2({ type: AuthEventType.ChangeIdentifier, payload: void 0 });
      return;
    }
    eventHandlerState.authState.socialLogin = true;
    if (linkAccount === "true") {
      eventHandlerState.router.push(LinkAccountRoute, { identifier: identifier2, code });
      return;
    }
    try {
      const authResult = yield passage.finishSocialAuthentication(code);
      emitEvent2({ type: AuthEventType.AuthSuccess, payload: { authResult } });
    } catch (error) {
      const psgError = error;
      console.error("Exchanging social token for Passage token failed:", psgError.message);
      emitEvent2({ type: AuthEventType.ChangeIdentifier, payload: void 0 });
    }
  });
}
var AuthEventType = /* @__PURE__ */ ((AuthEventType2) => {
  AuthEventType2["CreatedUser"] = "CreatedUser";
  AuthEventType2["ChangeIdentifier"] = "ChangeIdentifier";
  AuthEventType2["LoginUser"] = "LoginUser";
  AuthEventType2["EmailOrSMSAuth"] = "EmailOrSMSAuth";
  AuthEventType2["AuthSuccess"] = "AuthSuccess";
  AuthEventType2["EmailOrSMSAuthSuccess"] = "EmailOrSMSAuthSuccess";
  AuthEventType2["SocialAuthEvent"] = "SocialAuthEvent";
  return AuthEventType2;
})(AuthEventType || {});
class EventHandler {
  constructor(appInfo, router, passage) {
    this.appInfo = appInfo;
    this.router = router;
    this.passage = passage;
    this.authState = {
      userInitiatedFallback: false,
      socialLogin: false,
      linkingAccount: false
    };
    this.authOriginValid = false;
    this.passkeyFeatures = {
      securityKey: false,
      platform: false,
      syncedCredential: false,
      crossDeviceCredential: false,
      conditionalUI: false,
      isAvailable: false
    };
  }
  initializeEventHandler() {
    return __async(this, null, function* () {
      const passkeysEnabled = this.appInfo.auth_methods.passkeys !== void 0;
      if (passkeysEnabled) {
        this.authOriginValid = this.passage.checkWebauthnConfig(this.appInfo);
        if (this.authOriginValid) {
          this.passkeyFeatures = yield this.passage.getCredentialAvailable();
          if (isSafariVersionLessThan164()) {
            this.passkeyFeatures.conditionalUI = false;
          }
        }
      }
      const hasMagicLink = this.checkMagicLink();
      const hasSocialLogin = this.checkSocialLogin();
      if (!hasMagicLink && !hasSocialLogin) {
        this.router.push(this.router.homeRoute, {
          appInfo: this.appInfo,
          conditionalUI: this.passkeyFeatures.conditionalUI
        });
      }
    });
  }
  handleEvent(event) {
    return __async(this, null, function* () {
      switch (event.type) {
        case "CreatedUser":
          createdUserEventHandler(event.payload, this.eventHandlerState);
          break;
        case "ChangeIdentifier":
          changeIdenfitierEventHandler(this.eventHandlerState);
          break;
        case "LoginUser":
          loginUserEventHandler(event.payload, this.eventHandlerState, this.passage);
          break;
        case "EmailOrSMSAuth":
          emailOrSMSAuthEventHandler(event.payload, this.eventHandlerState);
          break;
        case "AuthSuccess":
          authSuccessEventHandler(event.payload, this.eventHandlerState, this.passage);
          break;
        case "EmailOrSMSAuthSuccess":
          emailOrSMSAuthSuccessEventHandler(event.payload, this.eventHandlerState);
          break;
        case "SocialAuthEvent":
          socialAuthEventHandler(this.eventHandlerState, this.passage);
          break;
      }
    });
  }
  get eventHandlerState() {
    return {
      appInfo: this.appInfo,
      webauthnAllowed: this.passkeyFeatures.platform,
      router: this.router,
      authState: this.authState,
      passkeyFeatures: this.passkeyFeatures
    };
  }
  checkMagicLink() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let magicLink = null;
    if (urlParams.has("psg_magic_link")) {
      magicLink = urlParams.get("psg_magic_link");
    } else if (urlParams.has("psg_verify_link")) {
      magicLink = urlParams.get("psg_verify_link");
    }
    if (magicLink !== null) {
      this.router.push(ActivateMagicLinkRoute, { magicLink, webauthnAllowed: this.passkeyFeatures.platform });
      return true;
    }
    return false;
  }
  checkSocialLogin() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has("code") && urlParams.has("state") && urlParams.has("link_account") && urlParams.has("provider_identifier")) {
      this.handleEvent({ type: "SocialAuthEvent", payload: void 0 });
      return true;
    }
    return false;
  }
}
let eventHandler = void 0;
function initEventHandler(appInfo, router, passage) {
  return __async(this, null, function* () {
    eventHandler = new EventHandler(appInfo, router, passage);
    yield eventHandler.initializeEventHandler();
  });
}
function getEventHandler() {
  return eventHandler;
}
function emitEvent(event) {
  return __async(this, null, function* () {
    return eventHandler == null ? void 0 : eventHandler.handleEvent(event);
  });
}
function useAuthEvent() {
  return {
    initEventHandler,
    getEventHandler,
    emitEvent
  };
}
const _sfc_main$z = defineComponent({
  __name: "Login",
  props: {
    canToggleLoginRegister: { type: Boolean },
    identifier: {},
    countryCode: {},
    appInfo: {},
    visible: { type: Boolean },
    conditionalUI: { type: Boolean },
    changeEmail: { type: Boolean }
  },
  emits: ["update:identifier", "update:countryCode"],
  setup(__props, { emit }) {
    const props = __props;
    const { t } = useLocale();
    const { passage } = usePassage();
    const error = ref("");
    const showPassageLogin = computed(() => {
      return Object.keys(props.appInfo.auth_methods).length > 0;
    });
    const identifierText = computed({
      get() {
        return props.identifier;
      },
      set(newIdentifier) {
        emit("update:identifier", newIdentifier);
      }
    });
    const countryCodeText = computed({
      get() {
        return props.countryCode;
      },
      set(newCountryCode) {
        emit("update:countryCode", newCountryCode);
      }
    });
    const inputForm = ref();
    watch(inputForm, () => __async(this, null, function* () {
      useCallbacks().onEvent.value(OnEventType.onLoaded);
      triggerConditionalUI();
    }));
    const identifierMode = computed(() => {
      var _a;
      return (_a = props.appInfo.allowed_identifier) != null ? _a : le.email;
    });
    function onSubmit(event) {
      return __async(this, null, function* () {
        const {
          identifier: identifier2,
          identifierExists,
          userStatus,
          userID,
          identifierType,
          emailVerified,
          phoneVerified,
          webauthnTypes
        } = event;
        const beforeAuthResult = useCallbacks().beforeAuth.value(identifier2, { authType: BeforeAuthCallbackType.Login });
        if (!beforeAuthResult) {
          return;
        }
        const errorString = checkIdentifierExistsAndStatus(identifierExists, identifierType, userStatus);
        if (errorString !== "") {
          error.value = errorString;
          return;
        }
        useAuthEvent().emitEvent({
          type: AuthEventType.LoginUser,
          payload: {
            identifier: identifier2,
            identifierType,
            userID,
            emailVerified,
            phoneVerified,
            webauthnTypes
          }
        });
      });
    }
    function checkIdentifierExistsAndStatus(identifierExists, identifierType, userStatus) {
      if (!identifierExists) {
        let identiferString = identifierType === IdentifierType.email ? t("email") : t("phone");
        identiferString = `${identiferString.charAt(0).toUpperCase()}${identiferString.slice(1)}`;
        let message = `${t("not-recognized", [identiferString])}.`;
        if (props.canToggleLoginRegister && props.appInfo.public_signup) {
          message = `${message} ${t("toggle-register")}`;
        }
        return message;
      }
      if (identifierExists && userStatus === re.INACTIVE) {
        return t("account-no-longer-active");
      }
      return "";
    }
    const showWelcomeBack = ref(false);
    let abortController;
    onMounted(() => {
      const lastLogin = getLastLogin();
      if (lastLogin && !props.changeEmail) {
        identifierText.value = lastLogin;
        showWelcomeBack.value = true;
      }
    });
    function triggerConditionalUI() {
      return __async(this, null, function* () {
        if (props.conditionalUI) {
          abortController = new AbortController();
          passage.loginConditional(abortController.signal).then((authResult) => {
            useAuthEvent().emitEvent({
              type: AuthEventType.AuthSuccess,
              payload: {
                authResult
              }
            });
          }).catch(() => {
          });
        }
      });
    }
    function cancelConditionalUI() {
      abortController == null ? void 0 : abortController.abort();
    }
    onBeforeUnmount(() => {
      cancelConditionalUI();
    });
    watch(
      () => props.visible,
      () => {
        if (showWelcomeBack.value === true) {
          identifierText.value = "";
        }
        showWelcomeBack.value = false;
        if (props.visible) {
          triggerConditionalUI();
        } else {
          cancelConditionalUI();
        }
      }
    );
    return (_ctx, _cache) => {
      return showPassageLogin.value ? (openBlock(), createBlock(ValidatedIdentifierForm, {
        key: 0,
        identifierMode: identifierMode.value,
        conditionalUI: _ctx.conditionalUI,
        showWelcomeBack: showWelcomeBack.value,
        "onUpdate:showWelcomeBack": _cache[0] || (_cache[0] = ($event) => showWelcomeBack.value = $event),
        identifier: identifierText.value,
        "onUpdate:identifier": _cache[1] || (_cache[1] = ($event) => identifierText.value = $event),
        validationError: error.value,
        "onUpdate:validationError": _cache[2] || (_cache[2] = ($event) => error.value = $event),
        countryCode: countryCodeText.value,
        "onUpdate:countryCode": _cache[3] || (_cache[3] = ($event) => countryCodeText.value = $event),
        onOnSubmit: _cache[4] || (_cache[4] = ($event) => onSubmit($event)),
        ref_key: "inputForm",
        ref: inputForm
      }, {
        loginInput: withCtx(() => [
          renderSlot(_ctx.$slots, "loginInput")
        ]),
        _: 3
      }, 8, ["identifierMode", "conditionalUI", "showWelcomeBack", "identifier", "validationError", "countryCode"])) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1$v = { key: 0 };
const _hoisted_2$k = {
  key: 0,
  class: "notification is-danger has-text-centered",
  "data-testid": "invalid-app-id"
};
const _sfc_main$y = defineComponent({
  __name: "Register",
  props: {
    canToggleLoginRegister: { type: Boolean },
    identifier: {},
    countryCode: {},
    appInfo: {}
  },
  emits: ["update:identifier", "update:countryCode", "authEvent"],
  setup(__props, { emit }) {
    const props = __props;
    const { t } = useLocale();
    const { passage } = usePassage();
    const { emitEvent: emitEvent2 } = useAuthEvent();
    const error = ref("");
    const metadata = ref({});
    const metadataComponent = ref();
    const showPassageRegistration = computed(() => {
      return Object.keys(props.appInfo.auth_methods).length > 0;
    });
    const identifierText = computed({
      get() {
        return props.identifier;
      },
      set(newIdentifier) {
        emit("update:identifier", newIdentifier);
      }
    });
    const countryCodeText = computed({
      get() {
        return props.countryCode;
      },
      set(newCountryCode) {
        emit("update:countryCode", newCountryCode);
      }
    });
    const publicSignup = computed(() => {
      return props.appInfo.public_signup;
    });
    const identifierMode = computed(() => {
      return props.appInfo.allowed_identifier;
    });
    function onSubmit(event) {
      return __async(this, null, function* () {
        const { identifier: identifier2, identifierExists, userStatus, identifierType } = event;
        let validMetadata = true;
        if (metadataComponent.value) {
          validMetadata = metadataComponent.value.validate();
        }
        if (identifierExists) {
          if (userStatus === re.ACTIVE) {
            let message = t("account-already-exists", [
              identifierType === IdentifierType.email ? t("email") : t("phone-number")
            ]);
            if (props.canToggleLoginRegister) {
              message = message + " " + t("toggle-login");
            }
            error.value = message;
            return;
          } else if (userStatus === re.INACTIVE) {
            error.value = t("account-no-longer-active");
            return;
          }
        }
        if (!validMetadata) {
          return;
        }
        let userMetadata = void 0;
        if (metadataComponent.value) {
          userMetadata = transformMetadata(metadata.value, props.appInfo.user_metadata_schema, true);
        }
        const beforeAuthResult = useCallbacks().beforeAuth.value(identifier2, {
          userMetadata,
          authType: BeforeAuthCallbackType.Register
        });
        if (!beforeAuthResult) {
          return;
        }
        try {
          yield passage.createUser({
            identifier: identifier2,
            user_metadata: userMetadata
          });
        } catch (err) {
          if (err instanceof p && err.message.startsWith("Public signup")) {
            error.value = err.message;
          } else {
            error.value = t("unexpected-error");
          }
          return;
        }
        emitEvent2({
          type: AuthEventType.CreatedUser,
          payload: {
            identifier: identifier2,
            identifierType
          }
        });
      });
    }
    return (_ctx, _cache) => {
      return showPassageRegistration.value ? (openBlock(), createElementBlock("div", _hoisted_1$v, [
        createVNode(ValidatedIdentifierForm, {
          identifierMode: identifierMode.value,
          identifier: identifierText.value,
          "onUpdate:identifier": _cache[0] || (_cache[0] = ($event) => identifierText.value = $event),
          validationError: error.value,
          "onUpdate:validationError": _cache[1] || (_cache[1] = ($event) => error.value = $event),
          countryCode: countryCodeText.value,
          "onUpdate:countryCode": _cache[2] || (_cache[2] = ($event) => countryCodeText.value = $event),
          onOnSubmit: _cache[3] || (_cache[3] = ($event) => onSubmit($event))
        }, {
          metadataFields: withCtx(() => [
            _ctx.appInfo && _ctx.appInfo.layouts.registration.length > 0 ? (openBlock(), createBlock(UserMetadata, {
              key: 0,
              isEditing: true,
              appInfo: _ctx.appInfo,
              layoutType: unref(LayoutType).Registration,
              userMetadata: metadata.value,
              ref_key: "metadataComponent",
              ref: metadataComponent
            }, null, 8, ["appInfo", "layoutType", "userMetadata"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["identifierMode", "identifier", "validationError", "countryCode"]),
        !publicSignup.value ? (openBlock(), createElementBlock("div", _hoisted_2$k, toDisplayString(unref(t)("public-registration-not-allowed")), 1)) : createCommentVNode("", true)
      ])) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1$u = {
  key: 0,
  class: "link has-text-centered"
};
const _hoisted_2$j = { class: "passage-branding" };
const _hoisted_3$h = {
  href: "https://passage.1password.com/",
  target: "_new_tab"
};
const _sfc_main$x = defineComponent({
  __name: "PassageBranding",
  props: {
    appInfo: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _ctx.appInfo.passage_branding ? (openBlock(), createElementBlock("div", _hoisted_1$u, [
        createBaseVNode("div", _hoisted_2$j, [
          createBaseVNode("a", _hoisted_3$h, [
            createVNode(unref(InlineSvg), {
              src: unref(Icons).poweredByPassage,
              alt: "Powered by Passage Icon"
            }, null, 8, ["src"])
          ])
        ])
      ])) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1$t = ["onClick", "data-testid"];
const _sfc_main$w = defineComponent({
  __name: "SocialAuthButton",
  props: {
    connection: {}
  },
  setup(__props) {
    const props = __props;
    const { t } = useLocale();
    const { theme } = useTheme();
    const { passage } = usePassage();
    const icon = computed(() => {
      switch (theme.value) {
        case Theme.Dark:
          return socialConnectionMetadata[props.connection].icons.dark;
        case Theme.Light:
        default:
          return socialConnectionMetadata[props.connection].icons.light;
      }
    });
    const buttonText = computed(() => {
      return t("continue-with-social", [t(socialConnectionMetadata[props.connection].nameKey)]);
    });
    const buttonIconAlt = computed(() => {
      return `${t(socialConnectionMetadata[props.connection].nameKey)} icon`;
    });
    function authorizeWith() {
      return __async(this, null, function* () {
        try {
          passage.authorizeWith(props.connection);
        } catch (error) {
          const psgError = error;
          if (psgError.statusCode === R.PSGSecureContextRequired) {
            console.error(psgError.message);
          } else {
            console.error("An unkown error occured while attempting to login with a social account.");
          }
        }
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        class: "button is-social",
        onClick: withModifiers(authorizeWith, ["prevent"]),
        "data-testid": `social-auth-button-${_ctx.connection}`
      }, [
        createVNode(unref(InlineSvg), {
          class: "social-button-icon",
          src: icon.value,
          alt: buttonIconAlt.value
        }, null, 8, ["src", "alt"]),
        createBaseVNode("span", null, toDisplayString(buttonText.value), 1)
      ], 8, _hoisted_1$t);
    };
  }
});
const _hoisted_1$s = {
  key: 0,
  class: "social-button-spacer"
};
const _sfc_main$v = defineComponent({
  __name: "SocialAuthButtonList",
  props: {
    appInfo: {}
  },
  setup(__props) {
    const props = __props;
    const socialLoginConnections = computed(() => {
      const allowedConnections = Object.keys(props.appInfo.social_connections);
      return allowedConnections.filter((connection) => {
        return Object.keys(socialConnectionMetadata).includes(connection);
      });
    });
    return (_ctx, _cache) => {
      return openBlock(true), createElementBlock(Fragment, null, renderList(socialLoginConnections.value, (connection, index) => {
        return openBlock(), createElementBlock("div", {
          class: "flex-column flex-center",
          key: connection
        }, [
          createVNode(_sfc_main$w, { connection }, null, 8, ["connection"]),
          index !== socialLoginConnections.value.length - 1 ? (openBlock(), createElementBlock("div", _hoisted_1$s)) : createCommentVNode("", true)
        ]);
      }), 128);
    };
  }
});
const _hoisted_1$r = {
  key: 0,
  class: "spacer-tall"
};
const _hoisted_2$i = {
  key: 1,
  class: "social-login-divider"
};
const _hoisted_3$g = /* @__PURE__ */ createBaseVNode("hr", { class: "divider-line" }, null, -1);
const _hoisted_4$f = {
  class: "divider-text",
  "data-testid": "social-auth-divider"
};
const _hoisted_5$e = /* @__PURE__ */ createBaseVNode("hr", { class: "divider-line" }, null, -1);
const _hoisted_6$c = {
  key: 2,
  class: "spacer-tall"
};
const _sfc_main$u = defineComponent({
  __name: "SocialAuth",
  props: {
    appInfo: {}
  },
  setup(__props) {
    const props = __props;
    const { t } = useLocale();
    const socialLoginConnections = computed(() => {
      return Object.keys(props.appInfo.social_connections);
    });
    const showDivider = computed(() => {
      const hasAuthMethods = Object.keys(props.appInfo.auth_methods).length > 0;
      const hasSocialLogin = socialLoginConnections.value.length > 0;
      return hasAuthMethods && hasSocialLogin;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        showDivider.value ? (openBlock(), createElementBlock("div", _hoisted_1$r)) : createCommentVNode("", true),
        showDivider.value ? (openBlock(), createElementBlock("div", _hoisted_2$i, [
          _hoisted_3$g,
          createBaseVNode("span", _hoisted_4$f, toDisplayString(unref(t)("or")), 1),
          _hoisted_5$e
        ])) : createCommentVNode("", true),
        showDivider.value ? (openBlock(), createElementBlock("div", _hoisted_6$c)) : createCommentVNode("", true),
        createVNode(_sfc_main$v, { "app-info": _ctx.appInfo }, null, 8, ["app-info"])
      ], 64);
    };
  }
});
const _hoisted_1$q = { class: "view-email-input auth-flex-container" };
const _hoisted_2$h = { class: "auth-flex-container" };
const _hoisted_3$f = { class: "title main-title has-text-centered" };
const _hoisted_4$e = /* @__PURE__ */ createBaseVNode("div", { style: { "height": "20px" } }, null, -1);
const _hoisted_5$d = /* @__PURE__ */ createBaseVNode("div", { class: "spacer-tall" }, null, -1);
const _hoisted_6$b = { class: "link has-text-centered" };
const _hoisted_7$b = { key: 0 };
const _hoisted_8$9 = ["onClick"];
const _hoisted_9$9 = { key: 1 };
const _hoisted_10$6 = ["onClick"];
const _sfc_main$t = defineComponent({
  __name: "AuthView",
  props: {
    register: { type: Boolean },
    appInfo: {},
    conditionalUI: { type: Boolean },
    changeEmail: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const { t } = useLocale();
    const showLogin = ref(!props.register);
    const identifier2 = ref("");
    const { defaultCountryCode } = useDefaultCountryCode();
    const countryCode = defaultCountryCode;
    const publicSignup = computed(() => {
      return props.appInfo.public_signup;
    });
    function changeInputPage() {
      showLogin.value = !showLogin.value;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$q, [
        createBaseVNode("div", _hoisted_2$h, [
          createBaseVNode("div", _hoisted_3$f, toDisplayString(showLogin.value ? unref(t)("login-title") : unref(t)("register-title")), 1),
          _hoisted_4$e,
          withDirectives(createVNode(_sfc_main$z, {
            identifier: identifier2.value,
            "onUpdate:identifier": _cache[0] || (_cache[0] = ($event) => identifier2.value = $event),
            canToggleLoginRegister: true,
            countryCode: unref(countryCode),
            "onUpdate:countryCode": _cache[1] || (_cache[1] = ($event) => isRef(countryCode) ? countryCode.value = $event : null),
            appInfo: _ctx.appInfo,
            visible: showLogin.value,
            conditionalUI: _ctx.conditionalUI,
            changeEmail: _ctx.changeEmail
          }, {
            loginInput: withCtx(() => [
              renderSlot(_ctx.$slots, "loginInput")
            ]),
            _: 3
          }, 8, ["identifier", "countryCode", "appInfo", "visible", "conditionalUI", "changeEmail"]), [
            [vShow, showLogin.value]
          ]),
          withDirectives(createVNode(_sfc_main$y, {
            identifier: identifier2.value,
            "onUpdate:identifier": _cache[2] || (_cache[2] = ($event) => identifier2.value = $event),
            canToggleLoginRegister: true,
            countryCode: unref(countryCode),
            "onUpdate:countryCode": _cache[3] || (_cache[3] = ($event) => isRef(countryCode) ? countryCode.value = $event : null),
            appInfo: _ctx.appInfo
          }, null, 8, ["identifier", "countryCode", "appInfo"]), [
            [vShow, !showLogin.value]
          ]),
          createVNode(_sfc_main$u, { "app-info": _ctx.appInfo }, null, 8, ["app-info"]),
          _hoisted_5$d,
          createBaseVNode("div", _hoisted_6$b, [
            showLogin.value && publicSignup.value ? (openBlock(), createElementBlock("div", _hoisted_7$b, [
              createTextVNode(toDisplayString(unref(t)("dont-have-an-account")) + " ", 1),
              createBaseVNode("a", {
                onClick: withModifiers(changeInputPage, ["prevent"]),
                role: "button",
                class: "body-link",
                "data-testid": "register-link"
              }, toDisplayString(unref(t)("register-here")), 9, _hoisted_8$9)
            ])) : !showLogin.value ? (openBlock(), createElementBlock("div", _hoisted_9$9, [
              createTextVNode(toDisplayString(unref(t)("already-have-an-account")) + " ", 1),
              createBaseVNode("a", {
                onClick: withModifiers(changeInputPage, ["prevent"]),
                role: "button",
                class: "body-link",
                "data-testid": "login-link"
              }, toDisplayString(unref(t)("login-here")), 9, _hoisted_10$6)
            ])) : createCommentVNode("", true)
          ])
        ]),
        createVNode(_sfc_main$x, { "app-info": _ctx.appInfo }, null, 8, ["app-info"])
      ]);
    };
  }
});
function useUIState() {
  const showFailure = ref(false);
  const showSuccess = ref(false);
  const loading = ref(false);
  const pageLoading = ref(true);
  const { t } = useLocale();
  const title = computed(() => {
    if (showSuccess.value) {
      return t("success");
    }
    if (showFailure.value) {
      return t("something-went-wrong");
    }
    return t("log-in-with-a-passkey");
  });
  const uiSuccess = () => {
    showSuccess.value = true;
    showFailure.value = false;
    loading.value = false;
  };
  const uiError = () => {
    showSuccess.value = false;
    showFailure.value = true;
    loading.value = false;
  };
  const uiLoading = () => {
    showSuccess.value = false;
    showFailure.value = false;
    loading.value = true;
  };
  return {
    showFailure,
    showSuccess,
    loading,
    pageLoading,
    title,
    uiSuccess,
    uiError,
    uiLoading
  };
}
var MagicLinkActionEnum = /* @__PURE__ */ ((MagicLinkActionEnum2) => {
  MagicLinkActionEnum2["LOGIN"] = "psg_magic_link";
  MagicLinkActionEnum2["VERIFY"] = "psg_verify_link";
  return MagicLinkActionEnum2;
})(MagicLinkActionEnum || {});
const useMagicLinkUtils = (magicLink) => {
  const magicLinkAction = ref();
  const invalidMagicLink = ref(false);
  const isMagicLinkValid = () => {
    const searchParams = new URLSearchParams(window.location.href.split("?")[1]);
    if (searchParams.has("psg_magic_link")) {
      magicLinkAction.value = "psg_magic_link";
    } else if (searchParams.has("psg_verify_link")) {
      magicLinkAction.value = "psg_verify_link";
    }
    if (!magicLinkAction.value || !magicLink) {
      invalidMagicLink.value = true;
    }
    return !invalidMagicLink.value;
  };
  return {
    magicLinkAction,
    invalidMagicLink,
    isMagicLinkValid
  };
};
const useMagicLinkActivation = ({ magicLink, uiState, magicLinkUtils, passage }) => {
  const authResult2 = ref(null);
  const onBeforeActivate = () => {
    uiState.uiLoading();
    authResult2.value = { auth_token: "", redirect_url: "" };
  };
  const onActivateError = () => {
    uiState.uiError();
  };
  const onActivateErrorInvalidMagicLink = () => {
    magicLinkUtils.invalidMagicLink.value = true;
    uiState.uiError();
  };
  const onActivateSuccess = (_0) => __async(void 0, [_0], function* ({
    webauthnAllowed,
    magicLinkAction,
    result
  }) {
    authResult2.value = result;
    if (!webauthnAllowed || magicLinkAction === MagicLinkActionEnum.VERIFY) {
      uiState.uiSuccess();
      yield new Promise((resolve) => {
        setTimeout(resolve, 2e3);
      });
    }
    if (authResult2.value.redirect_url) {
      useAuthEvent().emitEvent({
        type: magicLinkAction === MagicLinkActionEnum.VERIFY ? AuthEventType.AuthSuccess : AuthEventType.EmailOrSMSAuthSuccess,
        payload: {
          authResult: result
        }
      });
    }
  });
  const activateWithoutBiometrics = (webauthnAllowed, magicLinkAction) => __async(void 0, null, function* () {
    onBeforeActivate();
    try {
      const result = yield passage.magicLinkActivate(magicLink);
      onActivateSuccess({ webauthnAllowed, magicLinkAction, result });
    } catch (err) {
      if (err.statusCode === R.NotFound) {
        onActivateErrorInvalidMagicLink();
      } else {
        onActivateError();
      }
    }
  });
  return {
    authResult: authResult2,
    onBeforeActivate,
    onActivateError,
    onActivateErrorInvalidMagicLink,
    onActivateSuccess,
    activateWithoutBiometrics
  };
};
const _hoisted_1$p = { class: "auth-flex-container" };
const _hoisted_2$g = {
  class: "image has-text-centered",
  style: { "margin-top": "16px" }
};
const _hoisted_3$e = {
  class: "has-text-centered",
  "data-testid": "activate-magic-link-message",
  style: { "margin-top": "8px", "margin-bottom": "40px" }
};
const _hoisted_4$d = { key: 0 };
const _hoisted_5$c = { key: 1 };
const _hoisted_6$a = { key: 2 };
const _hoisted_7$a = { key: 3 };
const _hoisted_8$8 = { key: 4 };
const _hoisted_9$8 = {
  key: 0,
  class: "flex-row flex-center"
};
const _hoisted_10$5 = ["onClick", "disabled"];
const _hoisted_11$4 = { key: 0 };
const _hoisted_12$4 = { key: 1 };
const _hoisted_13$4 = { key: 2 };
const _sfc_main$s = defineComponent({
  __name: "ActivateMagicLink",
  props: {
    magicLink: {},
    webauthnAllowed: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const { t } = useLocale();
    const { passage } = usePassage();
    const uiState = useUIState();
    const { showFailure, showSuccess, loading, pageLoading, title } = uiState;
    const magicLinkUtils = useMagicLinkUtils(props.magicLink);
    const { isMagicLinkValid, invalidMagicLink, magicLinkAction } = magicLinkUtils;
    const activation = useMagicLinkActivation({
      uiState,
      magicLinkUtils,
      passage,
      magicLink: props.magicLink
    });
    function onButtonClick() {
      if (invalidMagicLink.value) {
        window.location.href = window.location.href.split("?")[0];
      } else {
        activation.activateWithoutBiometrics(props.webauthnAllowed, magicLinkAction.value);
      }
    }
    onMounted(() => __async(this, null, function* () {
      if (isMagicLinkValid()) {
        yield activation.activateWithoutBiometrics(props.webauthnAllowed, magicLinkAction.value);
        useCallbacks().onEvent.value(OnEventType.onMagicLinkActivateSuccess);
      } else {
        uiState.uiError();
      }
      pageLoading.value = false;
    }));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade",
        mode: "out-in",
        appear: ""
      }, {
        default: withCtx(() => [
          withDirectives(createBaseVNode("div", _hoisted_1$p, [
            createBaseVNode("div", {
              class: normalizeClass(["title has-text-centered", [unref(showSuccess) ? "main-title" : "secondary-title"]])
            }, toDisplayString(unref(showFailure) ? unref(invalidMagicLink) ? unref(t)("invalid-link") : unref(t)("device-login-failed-title") : unref(title)), 3),
            createBaseVNode("figure", _hoisted_2$g, [
              unref(showSuccess) ? (openBlock(), createBlock(unref(InlineSvg), {
                key: 0,
                src: unref(Icons).success,
                alt: "Magic link success"
              }, null, 8, ["src"])) : unref(showFailure) ? (openBlock(), createBlock(unref(InlineSvg), {
                key: 1,
                src: unref(Icons).failure,
                alt: "Magic link failure"
              }, null, 8, ["src"])) : createCommentVNode("", true)
            ]),
            createBaseVNode("div", _hoisted_3$e, [
              unref(showSuccess) && unref(magicLinkAction) === unref(MagicLinkActionEnum).LOGIN ? (openBlock(), createElementBlock("div", _hoisted_4$d, toDisplayString(unref(t)("successfully-logged-in-redirect")), 1)) : unref(showSuccess) && unref(magicLinkAction) === unref(MagicLinkActionEnum).VERIFY ? (openBlock(), createElementBlock("div", _hoisted_5$c, toDisplayString(unref(t)("successfully-changed-email")), 1)) : unref(showFailure) && unref(invalidMagicLink) && unref(magicLinkAction) === unref(MagicLinkActionEnum).VERIFY ? (openBlock(), createElementBlock("div", _hoisted_6$a, toDisplayString(unref(t)("link-invalid")), 1)) : unref(showFailure) && unref(invalidMagicLink) ? (openBlock(), createElementBlock("div", _hoisted_7$a, toDisplayString(unref(t)("login-link-invalid")), 1)) : unref(showFailure) && unref(magicLinkAction) === unref(MagicLinkActionEnum).VERIFY ? (openBlock(), createElementBlock("div", _hoisted_8$8, toDisplayString(unref(t)("verification-failed-please-try-again")), 1)) : createCommentVNode("", true)
            ]),
            unref(showFailure) || unref(showSuccess) ? (openBlock(), createElementBlock("div", _hoisted_9$8, [
              createBaseVNode("button", {
                onClick: withModifiers(onButtonClick, ["prevent"]),
                type: "button",
                class: normalizeClass(["button is-primary", { "is-loading": unref(loading) }]),
                part: "button",
                disabled: unref(loading),
                "data-testid": "activate-magic-link-button"
              }, [
                unref(showFailure) && unref(invalidMagicLink) ? (openBlock(), createElementBlock("span", _hoisted_11$4, toDisplayString(unref(t)("request-new-link")), 1)) : unref(showFailure) ? (openBlock(), createElementBlock("span", _hoisted_12$4, toDisplayString(unref(t)("try-again")), 1)) : unref(showSuccess) ? (openBlock(), createElementBlock("span", _hoisted_13$4, toDisplayString(unref(t)("redirect-now")), 1)) : createCommentVNode("", true)
              ], 10, _hoisted_10$5)
            ])) : createCommentVNode("", true)
          ], 512), [
            [vShow, !unref(pageLoading)]
          ])
        ]),
        _: 1
      });
    };
  }
});
const _hoisted_1$o = { class: "view-verify-token" };
const _sfc_main$r = defineComponent({
  __name: "ActivateMagicLinkView",
  props: {
    magicLink: {},
    webauthnAllowed: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$o, [
        createVNode(_sfc_main$s, {
          magicLink: _ctx.magicLink,
          webauthnAllowed: _ctx.webauthnAllowed
        }, null, 8, ["magicLink", "webauthnAllowed"])
      ]);
    };
  }
});
const _hoisted_1$n = { class: "view-email-input" };
const _sfc_main$q = defineComponent({
  __name: "LoginView",
  props: {
    register: { type: Boolean },
    appInfo: {},
    conditionalUI: { type: Boolean },
    changeEmail: { type: Boolean }
  },
  setup(__props) {
    const identifier2 = ref("");
    const { defaultCountryCode } = useDefaultCountryCode();
    const countryCode = defaultCountryCode;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$n, [
        createVNode(_sfc_main$z, {
          identifier: identifier2.value,
          "onUpdate:identifier": _cache[0] || (_cache[0] = ($event) => identifier2.value = $event),
          countryCode: unref(countryCode),
          "onUpdate:countryCode": _cache[1] || (_cache[1] = ($event) => isRef(countryCode) ? countryCode.value = $event : null),
          canToggleLoginRegister: false,
          appInfo: _ctx.appInfo,
          conditionalUI: _ctx.conditionalUI,
          changeEmail: _ctx.changeEmail
        }, {
          loginInput: withCtx(() => [
            renderSlot(_ctx.$slots, "loginInput")
          ]),
          _: 3
        }, 8, ["identifier", "countryCode", "appInfo", "conditionalUI", "changeEmail"]),
        createVNode(_sfc_main$u, { "app-info": _ctx.appInfo }, null, 8, ["app-info"]),
        createVNode(_sfc_main$x, { "app-info": _ctx.appInfo }, null, 8, ["app-info"])
      ]);
    };
  }
});
const _hoisted_1$m = { class: "view-email-input" };
const _sfc_main$p = defineComponent({
  __name: "RegisterView",
  props: {
    register: { type: Boolean },
    appInfo: {}
  },
  setup(__props) {
    const identifier2 = ref("");
    const { defaultCountryCode } = useDefaultCountryCode();
    const countryCode = defaultCountryCode;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$m, [
        createVNode(_sfc_main$y, {
          identifier: identifier2.value,
          "onUpdate:identifier": _cache[0] || (_cache[0] = ($event) => identifier2.value = $event),
          countryCode: unref(countryCode),
          "onUpdate:countryCode": _cache[1] || (_cache[1] = ($event) => isRef(countryCode) ? countryCode.value = $event : null),
          canToggleLoginRegister: false,
          appInfo: _ctx.appInfo
        }, null, 8, ["identifier", "countryCode", "appInfo"]),
        createVNode(_sfc_main$u, { "app-info": _ctx.appInfo }, null, 8, ["app-info"]),
        createVNode(_sfc_main$x, { "app-info": _ctx.appInfo }, null, 8, ["app-info"])
      ]);
    };
  }
});
const _sfc_main$o = defineComponent({
  name: "Spinner"
});
const _hoisted_1$l = { class: "spinner-box" };
const _hoisted_2$f = { class: "spinner-content" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$l, [
    createBaseVNode("div", _hoisted_2$f, [
      renderSlot(_ctx.$slots, "default")
    ])
  ]);
}
var Spinner = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render]]);
const _hoisted_1$k = { class: "auth-flex-container" };
const _hoisted_2$e = { class: "title has-text-centered" };
const _hoisted_3$d = {
  key: 0,
  class: "content has-text-centered",
  style: { "margin-bottom": "40px !important" }
};
const _hoisted_4$c = ["innerHTML"];
const _hoisted_5$b = { class: "flex-row flex-center" };
const _hoisted_6$9 = ["onClick", "disabled"];
const _hoisted_7$9 = /* @__PURE__ */ createBaseVNode("div", { class: "spacer" }, null, -1);
const _hoisted_8$7 = { class: "link has-text-centered" };
const _hoisted_9$7 = ["onClick"];
const _sfc_main$n = defineComponent({
  __name: "MagicLink",
  props: {
    identifier: {},
    userIsRegistering: { type: Boolean },
    identifierVerifying: { type: Boolean },
    setupNewDevice: { type: Boolean },
    identifierType: {}
  },
  setup(__props) {
    const props = __props;
    const { t, locale } = useLocale();
    const { passage } = usePassage();
    const { emitEvent: emitEvent2 } = useAuthEvent();
    const isEmail = computed(() => {
      return props.identifierType === IdentifierType.email;
    });
    const title = computed(() => {
      if (props.identifierVerifying) {
        if (isEmail.value) {
          if (props.userIsRegistering) {
            return t("verify-email-to-register");
          } else {
            return t("verify-email-to-login");
          }
        } else {
          if (props.userIsRegistering) {
            return t("verify-phone-to-register");
          } else {
            return t("verify-phone-to-login");
          }
        }
      } else {
        if (isEmail.value) {
          if (props.userIsRegistering) {
            return t("check-email-to-register");
          } else {
            return t("check-email-to-login");
          }
        } else {
          if (props.userIsRegistering) {
            return t("check-phone-to-register");
          } else {
            return t("check-phone-to-login");
          }
        }
      }
    });
    const message = computed(() => {
      let messageValue = "";
      const messageType = props.identifierType === IdentifierType.email ? t("messagetype-email") : t("messagetype-sms");
      const messageMedium = props.identifierType === IdentifierType.email ? t("email") : t("phone-number");
      const registrationType = props.userIsRegistering ? t("registration") : t("login");
      const loginMessage = props.identifierVerifying ? t("please-verify-identifier", [messageMedium, registrationType]) : t("you-will-be-automatically-signed-in");
      messageValue = t("weve-sent-messagetype", [messageType, props.identifier, loginMessage]);
      if (props.setupNewDevice && !props.userIsRegistering) {
        messageValue = t("we-dont-recognize-this-device") + " " + messageValue;
      }
      return messageValue;
    });
    onMounted(() => {
      if (props.userIsRegistering) {
        magicLinkSendRegister();
      } else {
        magicLinkSendLogin();
      }
    });
    function changeEmail() {
      localStorage.removeItem("email");
      localStorage.removeItem("magic_link_id");
      localStorage.removeItem("wait_count");
      waitForActivatedMagicLink(721);
      emitEvent2({ type: AuthEventType.ChangeIdentifier, payload: void 0 });
    }
    function resendMagicLink() {
      return __async(this, null, function* () {
        yield magicLinkSendLogin();
      });
    }
    const showWaiting = ref(false);
    const loading = ref(true);
    function magicLinkSendRegister() {
      return __async(this, null, function* () {
        showWaiting.value = false;
        loading.value = true;
        yield new Promise((resolve) => {
          setTimeout(resolve, 2e3);
        });
        try {
          const res = yield passage.newRegisterMagicLink(props.identifier, locale.value.split("-")[0]);
          if (res.id != "") {
            localStorage.setItem("magic_link_id", res.id);
            waitForActivatedMagicLink(0);
          }
        } catch (err) {
          console.log("magicLinkSend error", err);
        } finally {
          loading.value = false;
        }
      });
    }
    function magicLinkSendLogin() {
      return __async(this, null, function* () {
        showWaiting.value = false;
        loading.value = true;
        try {
          const res = yield passage.newLoginMagicLink(props.identifier, locale.value.split("-")[0]);
          if (res.id != "") {
            localStorage.setItem("magic_link_id", res.id);
            waitForActivatedMagicLink(0);
          }
        } catch (err) {
          console.log("magicLinkSend error", err);
        } finally {
          yield new Promise((resolve) => {
            setTimeout(resolve, 3e3);
          });
          loading.value = false;
        }
      });
    }
    let authResult = void 0;
    function lookupMagicLink() {
      return __async(this, null, function* () {
        const id = localStorage.getItem("magic_link_id");
        yield lookupMagicLinkActivated(id).then(() => __async(this, null, function* () {
          if (authResult && authResult.redirect_url != "") {
            localStorage.removeItem("magic_link_id");
            localStorage.removeItem("wait_count");
            useCallbacks().onEvent.value(OnEventType.onMagicLinkActivated);
            emitEvent2({
              type: AuthEventType.EmailOrSMSAuthSuccess,
              payload: {
                identifier: props.identifier,
                authResult
              }
            });
          }
        }));
      });
    }
    function lookupMagicLinkActivated(id) {
      return __async(this, null, function* () {
        yield passage.getMagicLinkStatus(id).then((res) => {
          waitForActivatedMagicLink(721);
          authResult = res;
        }).catch(() => {
        });
        return;
      });
    }
    let timer;
    function waitForActivatedMagicLink(count) {
      let i = count;
      if (i < 720) {
        showWaiting.value = true;
        timer = setTimeout(() => __async(this, null, function* () {
          delay(i);
          i++;
          waitForActivatedMagicLink(i);
        }), 5e3);
      } else {
        clearTimeout(timer);
        showWaiting.value = false;
        return;
      }
    }
    function delay(i) {
      lookupMagicLink();
      localStorage.setItem("wait_count", i.toString());
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$k, [
        createBaseVNode("div", _hoisted_2$e, [
          createBaseVNode("span", null, toDisplayString(title.value), 1)
        ]),
        createVNode(Spinner, null, {
          default: withCtx(() => [
            isEmail.value ? (openBlock(), createBlock(unref(InlineSvg), {
              key: 0,
              src: unref(Icons).email,
              alt: "Email envelope"
            }, null, 8, ["src"])) : (openBlock(), createBlock(unref(InlineSvg), {
              key: 1,
              src: unref(Icons).phone,
              alt: "Message bubbles"
            }, null, 8, ["src"]))
          ]),
          _: 1
        }),
        message.value ? (openBlock(), createElementBlock("div", _hoisted_3$d, [
          createBaseVNode("span", { innerHTML: message.value }, null, 8, _hoisted_4$c)
        ])) : createCommentVNode("", true),
        createBaseVNode("div", _hoisted_5$b, [
          createBaseVNode("button", {
            onClick: withModifiers(resendMagicLink, ["prevent"]),
            type: "button",
            class: "button is-primary",
            part: "button",
            disabled: loading.value
          }, toDisplayString(unref(t)("resend-isemail-email-message", [isEmail.value ? unref(t)("email") : unref(t)("message")])), 9, _hoisted_6$9)
        ]),
        _hoisted_7$9,
        createBaseVNode("div", _hoisted_8$7, [
          createBaseVNode("a", {
            onClick: withModifiers(changeEmail, ["prevent"]),
            role: "button",
            "data-testid": "change-email-button"
          }, toDisplayString(unref(t)("change-isemail-email-phone", [isEmail.value ? unref(t)("email") : unref(t)("phone")])), 9, _hoisted_9$7)
        ])
      ]);
    };
  }
});
const _hoisted_1$j = { class: "view-access-token auth-flex-container" };
const _sfc_main$m = defineComponent({
  __name: "MagicLinkView",
  props: {
    identifier: {},
    userIsRegistering: { type: Boolean },
    identifierVerifying: { type: Boolean },
    setupNewDevice: { type: Boolean },
    identifierType: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$j, [
        createVNode(_sfc_main$n, {
          identifier: _ctx.identifier,
          userIsRegistering: _ctx.userIsRegistering,
          identifierVerifying: _ctx.identifierVerifying,
          setupNewDevice: _ctx.setupNewDevice,
          identifierType: _ctx.identifierType
        }, null, 8, ["identifier", "userIsRegistering", "identifierVerifying", "setupNewDevice", "identifierType"])
      ]);
    };
  }
});
const _hoisted_1$i = { class: "passage-learnmore-modal" };
const _hoisted_2$d = { class: "passage-learnmore-top" };
const _hoisted_3$c = { class: "passage-learnmore-close-button" };
const _hoisted_4$b = { class: "passage-learnmore-content" };
const _hoisted_5$a = { style: { "margin-bottom": "32px" } };
const _sfc_main$l = defineComponent({
  __name: "LearnMoreLayout",
  setup(__props) {
    const { t } = useLocale();
    const showModal = ref(false);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        showModal.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "passage-learnmore",
          onClick: _cache[1] || (_cache[1] = ($event) => showModal.value = false)
        }, [
          createBaseVNode("div", _hoisted_1$i, [
            createBaseVNode("div", _hoisted_2$d, [
              createBaseVNode("div", {
                style: { "cursor": "pointer" },
                onClick: _cache[0] || (_cache[0] = ($event) => showModal.value = false)
              }, [
                createBaseVNode("span", _hoisted_3$c, toDisplayString(unref(t)("close")), 1),
                createVNode(unref(InlineSvg), {
                  src: unref(Icons).close
                }, null, 8, ["src"])
              ])
            ]),
            createBaseVNode("div", _hoisted_4$b, [
              renderSlot(_ctx.$slots, "body")
            ])
          ])
        ])) : createCommentVNode("", true),
        createBaseVNode("div", null, [
          createBaseVNode("div", _hoisted_5$a, [
            createBaseVNode("span", null, [
              renderSlot(_ctx.$slots, "cta"),
              createTextVNode(" \xA0 ")
            ]),
            createBaseVNode("a", {
              style: { "text-decoration": "underline" },
              onClick: _cache[2] || (_cache[2] = ($event) => showModal.value = true),
              role: "button"
            }, toDisplayString(unref(t)("learn-more")), 1),
            createTextVNode(" \u2192 ")
          ])
        ])
      ], 64);
    };
  }
});
const _hoisted_1$h = { style: { "margin-bottom": "12px" } };
const _hoisted_2$c = { class: "passage-learnmore-header" };
const _hoisted_3$b = { class: "passage-learnmore-body" };
const _hoisted_4$a = { class: "passage-learnmore-header" };
const _hoisted_5$9 = { class: "passage-learnmore-body" };
const _hoisted_6$8 = { class: "passage-learnmore-header" };
const _hoisted_7$8 = { class: "passage-learnmore-body" };
const _sfc_main$k = defineComponent({
  __name: "LearnMorePasskey",
  props: {
    cta: {}
  },
  setup(__props) {
    const { t } = useLocale();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$l, null, {
        cta: withCtx(() => [
          createBaseVNode("div", _hoisted_1$h, toDisplayString(unref(t)("passkeys-are-a-simple")), 1),
          createTextVNode(" " + toDisplayString(_ctx.cta), 1)
        ]),
        body: withCtx(() => [
          createBaseVNode("div", _hoisted_2$c, [
            createVNode(unref(InlineSvg), {
              src: unref(Icons).privateIcon,
              style: { "margin-right": "8px" }
            }, null, 8, ["src"]),
            createTextVNode(" " + toDisplayString(unref(t)("private")), 1)
          ]),
          createBaseVNode("div", _hoisted_3$b, toDisplayString(unref(t)("unlock-your-passkey")), 1),
          createBaseVNode("div", _hoisted_4$a, [
            createVNode(unref(InlineSvg), {
              src: unref(Icons).secure,
              style: { "margin-right": "8px" }
            }, null, 8, ["src"]),
            createTextVNode(" " + toDisplayString(unref(t)("secure")), 1)
          ]),
          createBaseVNode("div", _hoisted_5$9, toDisplayString(unref(t)("passkey-is-unique")), 1),
          createBaseVNode("div", _hoisted_6$8, [
            createVNode(unref(InlineSvg), {
              src: unref(Icons).simple,
              style: { "margin-right": "8px" }
            }, null, 8, ["src"]),
            createTextVNode(" " + toDisplayString(unref(t)("simple")), 1)
          ]),
          createBaseVNode("div", _hoisted_7$8, toDisplayString(unref(t)("easy-to-use")), 1)
        ]),
        _: 1
      });
    };
  }
});
const _hoisted_1$g = {
  class: "auth-flex-container",
  "data-tag": "register-device-message"
};
const _hoisted_2$b = { class: "title secondary-title has-text-centered" };
const _hoisted_3$a = { class: "image has-text-centered" };
const _hoisted_4$9 = { key: 0 };
const _hoisted_5$8 = { key: 1 };
const _hoisted_6$7 = { key: 1 };
const _hoisted_7$7 = { style: { "margin-bottom": "12px" } };
const _hoisted_8$6 = { style: { "margin-bottom": "24px" } };
const _hoisted_9$6 = { key: 2 };
const _hoisted_10$4 = { style: { "margin-bottom": "32px" } };
const _hoisted_11$3 = {
  key: 2,
  class: "flex-row flex-center"
};
const _hoisted_12$3 = ["onClick", "disabled"];
const _hoisted_13$3 = ["onClick", "disabled"];
const _hoisted_14$3 = {
  key: 3,
  class: "flex-column flex-center",
  style: { "margin": "auto" }
};
const _hoisted_15$3 = ["onClick", "disabled"];
const _hoisted_16$3 = ["onClick", "disabled"];
const _hoisted_17$3 = /* @__PURE__ */ createBaseVNode("div", { class: "spacer" }, null, -1);
const _hoisted_18$1 = {
  key: 4,
  class: "content has-text-centered",
  style: { "margin-top": "20px !important" }
};
const _hoisted_19$1 = { class: "link" };
const _hoisted_20$1 = ["onClick"];
const _hoisted_21$1 = { class: "link" };
const _hoisted_22$1 = ["onClick"];
const _hoisted_23$1 = {
  key: 0,
  class: "link"
};
const _hoisted_24$1 = ["onClick"];
const _sfc_main$j = defineComponent({
  __name: "RegisterDevice",
  props: {
    identifier: {},
    identifierType: {},
    appInfo: {},
    passkeyFeatures: {}
  },
  setup(__props) {
    const props = __props;
    const showFailure = ref(false);
    const loading = ref(false);
    const { t, te } = useLocale();
    const { passage } = usePassage();
    const { emitEvent: emitEvent2 } = useAuthEvent();
    const { autofocusButton } = useAutofocusButton();
    const supportsPlatform = computed(() => {
      return props.passkeyFeatures.platform;
    });
    const supportsCrossPlatform = computed(() => {
      return props.passkeyFeatures.securityKey;
    });
    const isEmail = computed(() => {
      return props.identifierType === IdentifierType.email;
    });
    const fallbackAuth = computed(() => {
      return emailOrSMS(props.appInfo);
    });
    const supportsFallback = computed(() => {
      return fallbackAuth.value !== EmailOrSMS.None;
    });
    const fallbackRegisterWithCodeEmailOrTextBtnCopy = computed(() => {
      if (fallbackAuth.value === EmailOrSMS.SMS) {
        return te("register-with-code") ? t("register-with-code") : "Register with a code";
      } else {
        return t("register-with-link", [isEmail.value ? t("email") : t("sms-text")]);
      }
    });
    const fallbackSendCodeEmailOrTextBtnCopy = computed(() => {
      if (fallbackAuth.value === EmailOrSMS.SMS) {
        return te("send-code") ? t("send-code") : "Send code";
      } else {
        return t("send-email-or-text-link", [isEmail.value ? t("email") : t("sms-text")]);
      }
    });
    const failureCreateText = computed(() => {
      switch (fallbackAuth.value) {
        case EmailOrSMS.SMS:
          return te("passkey-create-fail-try-code") ? t("passkey-create-fail-try-code") : "Unable to create a passkey. Try again or register with a one-time code.";
        case EmailOrSMS.Email:
          return t("passkey-create-fail-try-link");
        case EmailOrSMS.None:
          return t("passkey-create-fail-no-fallback");
      }
    });
    let previousAttachment = q.Platform;
    function signUpWebAuthn(identifier2, authenticatorAttachment) {
      return __async(this, null, function* () {
        loading.value = true;
        try {
          previousAttachment = authenticatorAttachment;
          const authResult = yield passage.register(identifier2, { authenticatorAttachment });
          loading.value = false;
          emitEvent2({
            type: AuthEventType.AuthSuccess,
            payload: {
              authResult,
              identifier: props.identifier
            }
          });
        } catch (err) {
          showFailure.value = true;
          loading.value = false;
        }
      });
    }
    function registerWithFallback() {
      emitEvent2({
        type: AuthEventType.EmailOrSMSAuth,
        payload: {
          identifier: props.identifier,
          identifierType: props.identifierType,
          userIsRegistering: true,
          userInitiated: true
        }
      });
    }
    function changeEmail() {
      localStorage.removeItem("email");
      useAuthEvent().emitEvent({ type: AuthEventType.ChangeIdentifier, payload: void 0 });
    }
    function primaryRegister() {
      if (supportsPlatform.value === true) {
        signUpWebAuthn(props.identifier, q.Platform);
      } else {
        signUpWebAuthn(props.identifier, q.CrossPlatform);
      }
    }
    function secondaryRegister() {
      signUpWebAuthn(props.identifier, q.CrossPlatform);
    }
    function tryAgain() {
      signUpWebAuthn(props.identifier, previousAttachment);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$g, [
        createBaseVNode("div", _hoisted_2$b, toDisplayString(supportsPlatform.value ? unref(t)("register-with-a-passkey") : unref(t)("register-passkey-another-device")), 1),
        createBaseVNode("figure", _hoisted_3$a, [
          createVNode(unref(InlineSvg), {
            src: unref(Icons).passkey,
            alt: "Register with a passkey"
          }, null, 8, ["src"])
        ]),
        showFailure.value ? (openBlock(), createElementBlock("div", _hoisted_4$9, [
          createBaseVNode("p", null, toDisplayString(failureCreateText.value), 1)
        ])) : (openBlock(), createElementBlock("div", _hoisted_5$8, [
          supportsPlatform.value && !supportsCrossPlatform.value ? (openBlock(), createBlock(_sfc_main$k, {
            key: 0,
            cta: unref(t)("register-your-account")
          }, null, 8, ["cta"])) : createCommentVNode("", true),
          supportsPlatform.value && supportsCrossPlatform.value ? (openBlock(), createElementBlock("div", _hoisted_6$7, [
            createBaseVNode("div", _hoisted_7$7, toDisplayString(unref(t)("passkeys-are-a-simple")), 1),
            createBaseVNode("div", _hoisted_8$6, toDisplayString(unref(t)("passkey-register-options")), 1)
          ])) : createCommentVNode("", true),
          !supportsPlatform.value && supportsCrossPlatform.value ? (openBlock(), createElementBlock("div", _hoisted_9$6, [
            createBaseVNode("div", _hoisted_10$4, toDisplayString(unref(t)("passkeys-not-supported-try-another-device")), 1)
          ])) : createCommentVNode("", true)
        ])),
        showFailure.value ? (openBlock(), createElementBlock("div", _hoisted_11$3, [
          createBaseVNode("button", {
            onClick: withModifiers(tryAgain, ["prevent"]),
            type: "button",
            part: "button",
            class: "button is-primary",
            disabled: loading.value,
            style: { "margin-right": "5px" }
          }, toDisplayString(unref(t)("try-again")), 9, _hoisted_12$3),
          supportsFallback.value ? (openBlock(), createElementBlock("button", {
            key: 0,
            onClick: withModifiers(registerWithFallback, ["prevent"]),
            type: "button",
            part: "button button-secondary",
            class: "button is-secondary",
            disabled: loading.value,
            style: { "margin-left": "5px" },
            "data-testid": "login-with-email-button",
            ref_key: "autofocusButton",
            ref: autofocusButton
          }, toDisplayString(fallbackSendCodeEmailOrTextBtnCopy.value), 9, _hoisted_13$3)) : createCommentVNode("", true)
        ])) : (openBlock(), createElementBlock("div", _hoisted_14$3, [
          createBaseVNode("button", {
            onClick: withModifiers(primaryRegister, ["prevent"]),
            type: "button",
            class: normalizeClass(["button", [{ "is-loading": loading.value }]]),
            part: "button",
            disabled: loading.value,
            "data-testid": "register-main-button",
            tabindex: "0",
            ref_key: "autofocusButton",
            ref: autofocusButton,
            style: { "margin": "8px 0px" }
          }, [
            createBaseVNode("span", null, toDisplayString(supportsPlatform.value ? unref(t)("register-with-passkey") : unref(t)("use-another-device")), 1)
          ], 10, _hoisted_15$3),
          supportsPlatform.value && supportsCrossPlatform.value ? (openBlock(), createElementBlock("button", {
            key: 0,
            onClick: withModifiers(secondaryRegister, ["prevent"]),
            type: "button",
            class: normalizeClass(["button is-secondary", [{ "is-loading": loading.value }]]),
            part: "button button-secondary",
            style: { "width": "100%", "margin": "8px 0px" },
            disabled: loading.value,
            "data-testid": "register-secondary-button",
            tabindex: "0",
            ref_key: "autofocusButton",
            ref: autofocusButton
          }, [
            createBaseVNode("span", null, toDisplayString(unref(t)("use-another-device")), 1)
          ], 10, _hoisted_16$3)) : createCommentVNode("", true)
        ])),
        _hoisted_17$3,
        showFailure.value ? (openBlock(), createElementBlock("div", _hoisted_18$1, [
          createBaseVNode("div", _hoisted_19$1, [
            createBaseVNode("a", {
              onClick: withModifiers(changeEmail, ["prevent"]),
              role: "button",
              "data-testid": "change-email-button"
            }, toDisplayString(unref(t)("change-isemail-email-phone", [isEmail.value ? unref(t)("email") : unref(t)("phone")])), 9, _hoisted_20$1)
          ])
        ])) : createCommentVNode("", true),
        !showFailure.value ? (openBlock(), createElementBlock("div", {
          key: 5,
          class: normalizeClass(["flex-row flex-wrap", supportsFallback.value ? "flex-between" : "flex-center"])
        }, [
          createBaseVNode("div", _hoisted_21$1, [
            createBaseVNode("a", {
              onClick: withModifiers(changeEmail, ["prevent"]),
              role: "button",
              "data-testid": "change-email-button"
            }, toDisplayString(unref(t)("back")), 9, _hoisted_22$1)
          ]),
          supportsFallback.value ? (openBlock(), createElementBlock("div", _hoisted_23$1, [
            createBaseVNode("a", {
              onClick: withModifiers(registerWithFallback, ["prevent"]),
              role: "button",
              "data-testid": "register-email-button"
            }, toDisplayString(fallbackRegisterWithCodeEmailOrTextBtnCopy.value), 9, _hoisted_24$1)
          ])) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true)
      ]);
    };
  }
});
const _sfc_main$i = defineComponent({
  __name: "RegisterDeviceView",
  props: {
    identifier: {},
    identifierType: {},
    appInfo: {},
    passkeyFeatures: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$j, normalizeProps(guardReactiveProps(props)), null, 16);
    };
  }
});
const _hoisted_1$f = { class: "auth-flex-container" };
const _hoisted_2$a = { class: "title has-text-centered" };
const _hoisted_3$9 = {
  class: "image has-text-centered",
  style: { "margin-top": "8px" }
};
const _hoisted_4$8 = {
  key: 1,
  class: "wrap-text",
  style: { "margin-bottom": "5px !important" }
};
const _hoisted_5$7 = { "data-testid": "failure-message" };
const _hoisted_6$6 = { style: { "margin": "0px", "margin-top": "8px", "margin-bottom": "40px" } };
const _hoisted_7$6 = {
  key: 2,
  class: "flex-row flex-center"
};
const _hoisted_8$5 = ["onClick", "disabled"];
const _hoisted_9$5 = ["onClick", "disabled"];
const _hoisted_10$3 = /* @__PURE__ */ createBaseVNode("div", { class: "spacer" }, null, -1);
const _hoisted_11$2 = {
  key: 3,
  class: "content has-text-centered",
  style: { "margin-top": "20px !important" }
};
const _hoisted_12$2 = { class: "link" };
const _hoisted_13$2 = ["onClick"];
const _hoisted_14$2 = { class: "link" };
const _hoisted_15$2 = ["onClick"];
const _hoisted_16$2 = {
  key: 0,
  class: "link"
};
const _hoisted_17$2 = ["onClick"];
const _sfc_main$h = defineComponent({
  __name: "WebauthnSignIn",
  props: {
    identifier: {},
    identifierType: {},
    appInfo: {},
    userIsVerifying: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const showFailure = ref(false);
    const loading = ref(false);
    const { t, te } = useLocale();
    const { passage } = usePassage();
    const { emitEvent: emitEvent2 } = useAuthEvent();
    const title = computed(() => {
      if (props.userIsVerifying) {
        return t("verify-account");
      }
      return t("log-in-with-a-passkey");
    });
    const isEmail = computed(() => {
      return props.identifierType === IdentifierType.email;
    });
    const { autofocusButton } = useAutofocusButton();
    const fallbackAuth = computed(() => {
      return emailOrSMS(props.appInfo);
    });
    const supportsFallback = computed(() => {
      return fallbackAuth.value !== EmailOrSMS.None;
    });
    const fallbackSendCodeEmailOrTextBtnCopy = computed(() => {
      if (fallbackAuth.value === EmailOrSMS.SMS) {
        return te("send-code") ? t("send-code") : "Send code";
      } else {
        return t("send-email-or-text-link", [isEmail.value ? t("email") : t("sms-text")]);
      }
    });
    const loginWithCodeEmailOrTextBtnCopy = computed(() => {
      if (fallbackAuth.value === EmailOrSMS.SMS) {
        return te("login-with-code") ? t("login-with-code") : "Login with a code";
      } else {
        return t("login-with-link", [isEmail.value ? t("email") : t("sms-text")]);
      }
    });
    const failureLoginText = computed(() => {
      switch (fallbackAuth.value) {
        case EmailOrSMS.SMS:
          return te("passkey-login-fail-try-code") ? t("passkey-login-fail-try-code") : "Unable to log in with a passkey. Try again or log in with a one-time code.";
        case EmailOrSMS.Email:
          return t("passkey-login-fail-try-link");
        case EmailOrSMS.None:
          return t("passkey-login-fail-no-fallback");
      }
    });
    function signInWebAuthn() {
      return __async(this, null, function* () {
        showFailure.value = false;
        if (!props.identifier) {
          return;
        }
        loading.value = true;
        try {
          const authResult = yield passage.login(props.identifier);
          emitEvent2({
            type: AuthEventType.AuthSuccess,
            payload: {
              authResult,
              identifier: props.identifier
            }
          });
          loading.value = false;
        } catch (err) {
          const error = err;
          showFailure.value = true;
          loading.value = false;
          if (error.statusCode === R.PSGParsePublicKeyForLoginFailed) {
            showFailure.value = true;
          } else {
            emitEvent2({
              type: AuthEventType.EmailOrSMSAuth,
              payload: {
                identifier: props.identifier,
                identifierType: props.identifierType,
                userInitiated: false
              }
            });
          }
        }
      });
    }
    function loginWithFallback() {
      emitEvent2({
        type: AuthEventType.EmailOrSMSAuth,
        payload: {
          identifier: props.identifier,
          identifierType: props.identifierType,
          userInitiated: true
        }
      });
    }
    function changeEmail() {
      localStorage.removeItem("email");
      emitEvent2({
        type: AuthEventType.ChangeIdentifier,
        payload: void 0
      });
    }
    onMounted(() => {
      signInWebAuthn();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$f, [
        createBaseVNode("div", _hoisted_2$a, toDisplayString(title.value), 1),
        createBaseVNode("figure", _hoisted_3$9, [
          createVNode(unref(InlineSvg), {
            src: unref(Icons).passkey,
            alt: "Log in with a passkey",
            style: { "margin": "5px" }
          }, null, 8, ["src"])
        ]),
        !showFailure.value ? (openBlock(), createBlock(_sfc_main$k, {
          key: 0,
          cta: unref(t)("log-into-your-account")
        }, null, 8, ["cta"])) : showFailure.value ? (openBlock(), createElementBlock("div", _hoisted_4$8, [
          createBaseVNode("div", _hoisted_5$7, [
            createBaseVNode("p", _hoisted_6$6, toDisplayString(failureLoginText.value), 1)
          ])
        ])) : createCommentVNode("", true),
        showFailure.value ? (openBlock(), createElementBlock("div", _hoisted_7$6, [
          createBaseVNode("button", {
            onClick: withModifiers(signInWebAuthn, ["prevent"]),
            type: "button",
            part: "button",
            class: "button is-primary",
            disabled: loading.value,
            style: { "margin-right": "5px" }
          }, toDisplayString(unref(t)("try-again")), 9, _hoisted_8$5),
          supportsFallback.value ? (openBlock(), createElementBlock("button", {
            key: 0,
            onClick: withModifiers(loginWithFallback, ["prevent"]),
            type: "button",
            part: "button button-secondary",
            class: "button is-secondary",
            disabled: loading.value,
            style: { "margin-left": "5px" },
            "data-testid": "login-with-email-button",
            ref_key: "autofocusButton",
            ref: autofocusButton
          }, toDisplayString(fallbackSendCodeEmailOrTextBtnCopy.value), 9, _hoisted_9$5)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        _hoisted_10$3,
        showFailure.value ? (openBlock(), createElementBlock("div", _hoisted_11$2, [
          createBaseVNode("div", _hoisted_12$2, [
            createBaseVNode("a", {
              onClick: withModifiers(changeEmail, ["prevent"]),
              role: "button",
              "data-testid": "change-email-button"
            }, toDisplayString(unref(t)("change-isemail-email-phone", [isEmail.value ? unref(t)("email") : unref(t)("phone")])), 9, _hoisted_13$2)
          ])
        ])) : createCommentVNode("", true),
        !showFailure.value ? (openBlock(), createElementBlock("div", {
          key: 4,
          class: normalizeClass(["flex-row flex-wrap", supportsFallback.value ? "flex-between" : "flex-center"])
        }, [
          createBaseVNode("div", _hoisted_14$2, [
            createBaseVNode("a", {
              onClick: withModifiers(changeEmail, ["prevent"]),
              role: "button",
              "data-testid": "change-email-button"
            }, toDisplayString(unref(t)("back")), 9, _hoisted_15$2)
          ]),
          supportsFallback.value ? (openBlock(), createElementBlock("div", _hoisted_16$2, [
            createBaseVNode("a", {
              onClick: withModifiers(loginWithFallback, ["prevent"]),
              role: "button",
              "data-testid": "register-email-button"
            }, toDisplayString(loginWithCodeEmailOrTextBtnCopy.value), 9, _hoisted_17$2)
          ])) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true)
      ]);
    };
  }
});
const _hoisted_1$e = { class: "view-webauthn-sign-in auth-flex-container" };
const _sfc_main$g = defineComponent({
  __name: "WebauthnSignInView",
  props: {
    identifier: {},
    identifierType: {},
    appInfo: {},
    userIsVerifying: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$e, [
        createVNode(_sfc_main$h, {
          identifier: _ctx.identifier,
          identifierType: _ctx.identifierType,
          appInfo: _ctx.appInfo,
          userIsVerifying: _ctx.userIsVerifying
        }, null, 8, ["identifier", "identifierType", "appInfo", "userIsVerifying"])
      ]);
    };
  }
});
const _hoisted_1$d = {
  style: { "display": "flex", "align-items": "center" },
  class: "psg-otp-single-input-container"
};
const _hoisted_2$9 = ["data-testid", "type", "inputtype", "placeholder", "inputmode", "disabled", "maxlength", "autocomplete"];
const _hoisted_3$8 = { key: 0 };
const _hoisted_4$7 = ["innerHTML"];
const _sfc_main$f = defineComponent({
  __name: "OneTimePasscodeSingleInput",
  props: {
    conditionalClass: {},
    focus: { type: Boolean },
    inputClasses: { default: () => [] },
    inputmode: { default: "numeric" },
    inputType: { default: "number" },
    isDisabled: { type: Boolean },
    isLastChild: { type: Boolean },
    placeholder: {},
    separator: { default: "" },
    shouldAutoFocus: { type: Boolean, default: false },
    value: { default: "" },
    isFirstChild: { type: Boolean },
    inputIdx: {},
    inputCount: {}
  },
  emits: ["on-change", "on-keydown", "on-paste", "on-focus", "on-blur"],
  setup(__props, { emit }) {
    const props = __props;
    const model = ref(props.value || "");
    const input = ref(null);
    const inputTypeValue = computed(() => {
      return props.inputType === "letter-numeric" ? "text" : props.inputType;
    });
    const handleOnChange = () => {
      model.value = model.value.toString();
      if (model.value.length > 1) {
        model.value = model.value.slice(0, 1);
      }
      return emit("on-change", model.value);
    };
    const isCodeLetter = (charCode) => charCode >= 65 && charCode <= 90;
    const isCodeNumeric = (charCode) => charCode >= 48 && charCode <= 57 || charCode >= 96 && charCode <= 105;
    const handleOnKeyDown = (event) => {
      if (props.isDisabled) {
        event.preventDefault();
      }
      const keyEvent = event || window.event;
      const charCode = keyEvent.which ? keyEvent.which : keyEvent.keyCode;
      if (isCodeNumeric(charCode) || props.inputType === "letter-numeric" && isCodeLetter(charCode) || [8, 9, 13, 37, 39, 46, 86].includes(charCode)) {
        emit("on-keydown", event);
      } else {
        keyEvent.preventDefault();
      }
    };
    const handleOnPaste = (event) => emit("on-paste", event);
    const handleOnFocus = () => {
      input.value.select();
      return emit("on-focus");
    };
    const handleOnBlur = () => emit("on-blur");
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          model.value = newValue;
        }
      }
    );
    watch(
      () => props.focus,
      (newFocusValue, oldFocusValue) => {
        if (oldFocusValue !== newFocusValue && input.value && props.focus) {
          input.value.focus();
          input.value.select();
        }
      }
    );
    onMounted(() => {
      if (input.value && props.focus && props.shouldAutoFocus) {
        input.value.focus();
        input.value.select();
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$d, [
        withDirectives(createBaseVNode("input", {
          "data-testid": `otp-single-input-${_ctx.inputIdx}`,
          type: inputTypeValue.value,
          inputtype: inputTypeValue.value,
          placeholder: _ctx.placeholder,
          inputmode: _ctx.inputmode,
          disabled: _ctx.isDisabled,
          ref_key: "input",
          ref: input,
          pattern: "[0-9]*",
          maxlength: _ctx.isFirstChild ? _ctx.inputCount : 1,
          min: "0",
          max: "9",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value = $event),
          class: normalizeClass(["psg-input", "psg-otp-input", [..._ctx.inputClasses || []]]),
          onInput: handleOnChange,
          onKeydown: handleOnKeyDown,
          onPaste: handleOnPaste,
          onFocus: handleOnFocus,
          onBlur: handleOnBlur,
          autocomplete: _ctx.isFirstChild ? "one-time-code" : "off"
        }, null, 42, _hoisted_2$9), [
          [vModelDynamic, model.value]
        ]),
        !_ctx.isLastChild && _ctx.separator ? (openBlock(), createElementBlock("span", _hoisted_3$8, [
          createBaseVNode("span", { innerHTML: _ctx.separator }, null, 8, _hoisted_4$7)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const _hoisted_1$c = {
  style: { "display": "flex", "justify-content": "space-between" },
  class: "psg-otp-input-container"
};
const _hoisted_2$8 = {
  key: 0,
  autocomplete: "off",
  name: "hidden",
  type: "text",
  style: { "display": "none" }
};
const _sfc_main$e = defineComponent({
  __name: "OneTimePasscodeInput",
  props: {
    value: { default: "" },
    numInputs: { default: 6 },
    separator: { default: "" },
    inputClasses: {},
    conditionalClass: { default: () => [] },
    inputType: { default: "number" },
    inputmode: { default: "numeric" },
    shouldAutoFocus: { type: Boolean, default: false },
    placeholder: { default: () => [] },
    isDisabled: { type: Boolean, default: false },
    disableNonCurrent: { type: Boolean, default: false }
  },
  emits: ["update:value", "on-complete", "on-change"],
  setup(__props, { emit }) {
    const props = __props;
    const activeInput = ref(0);
    const otp = ref([]);
    const oldOtp = ref([]);
    watch(
      () => props.value,
      (val) => {
        const fill = (unref(val) || "").padEnd(props.numInputs, " ").split("");
        otp.value = fill;
      },
      { immediate: true }
    );
    const handleOnFocus = (index) => {
      activeInput.value = index;
    };
    const handleOnBlur = () => {
      activeInput.value = -1;
    };
    const checkFilledAllInputs = () => {
      if (otp.value.join("").length === props.numInputs) {
        emit("update:value", otp.value.join(""));
        return emit("on-complete", otp.value.join(""));
      }
      return "Wait until the user enters the required number of characters";
    };
    const focusInput = (input) => {
      activeInput.value = Math.max(Math.min(props.numInputs - 1, input), 0);
    };
    const focusNextInput = () => {
      if (props.disableNonCurrent) {
        setTimeout(() => {
          focusInput(activeInput.value + 1);
        }, 200);
      } else {
        focusInput(activeInput.value + 1);
      }
    };
    const focusPrevInput = () => {
      focusInput(activeInput.value - 1);
    };
    const changeCodeAtFocus = (value) => {
      oldOtp.value = Object.assign([], otp.value);
      otp.value[activeInput.value] = value;
      if (oldOtp.value.join("") !== otp.value.join("")) {
        emit("update:value", otp.value.join(""));
        emit("on-change", otp.value.join(""));
      }
    };
    const handleOnPaste = (event) => {
      var _a;
      event.preventDefault();
      const pastedData = (_a = event.clipboardData) == null ? void 0 : _a.getData("text/plain").slice(0, props.numInputs - activeInput.value).split("");
      if (props.inputType === "number" && !(pastedData == null ? void 0 : pastedData.join("").match(/^\d+$/))) {
        return "Invalid pasted data";
      }
      if (props.inputType === "letter-numeric" && !(pastedData == null ? void 0 : pastedData.join("").match(/^\w+$/))) {
        return "Invalid pasted data";
      }
      const currentCharsInOTP = otp.value.slice(0, activeInput.value);
      const combinedWithPastedData = currentCharsInOTP.concat(pastedData || "");
      combinedWithPastedData.slice(0, props.numInputs).forEach((value, i) => {
        otp.value[i] = value;
      });
      focusInput(combinedWithPastedData.slice(0, props.numInputs).length);
      return checkFilledAllInputs();
    };
    const handleOnChange = (value) => {
      changeCodeAtFocus(value);
      focusNextInput();
    };
    const handleOnKeyDown = (event) => {
      switch (event.keyCode) {
        case 8:
          event.preventDefault();
          changeCodeAtFocus("");
          focusPrevInput();
          break;
        case 46:
          event.preventDefault();
          changeCodeAtFocus("");
          break;
        case 37:
          event.preventDefault();
          focusPrevInput();
          break;
        case 39:
          event.preventDefault();
          focusNextInput();
          break;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$c, [
        _ctx.inputType === "password" ? (openBlock(), createElementBlock("input", _hoisted_2$8)) : createCommentVNode("", true),
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.numInputs, (_, i) => {
          return openBlock(), createBlock(_sfc_main$f, {
            key: i,
            focus: activeInput.value === i,
            value: otp.value[i],
            separator: _ctx.separator,
            "input-type": _ctx.inputType,
            inputmode: _ctx.inputmode,
            "input-classes": _ctx.inputClasses,
            conditionalClass: _ctx.conditionalClass[i],
            "is-last-child": i === _ctx.numInputs - 1,
            "is-first-child": i === 0,
            "should-auto-focus": _ctx.shouldAutoFocus,
            placeholder: _ctx.placeholder[i],
            "is-disabled": _ctx.isDisabled || _ctx.disableNonCurrent && i > otp.value.join("").trim().length,
            "input-idx": i,
            "input-count": _ctx.numInputs,
            onOnChange: handleOnChange,
            onOnKeydown: handleOnKeyDown,
            onOnPaste: handleOnPaste,
            onOnFocus: ($event) => handleOnFocus(i),
            onOnBlur: handleOnBlur
          }, null, 8, ["focus", "value", "separator", "input-type", "inputmode", "input-classes", "conditionalClass", "is-last-child", "is-first-child", "should-auto-focus", "placeholder", "is-disabled", "input-idx", "input-count", "onOnFocus"]);
        }), 128))
      ]);
    };
  }
});
const _hoisted_1$b = { class: "auth-flex-container" };
const _hoisted_2$7 = {
  class: "flex flex-column",
  style: { "flex-grow": "1" }
};
const _hoisted_3$7 = { class: "title has-text-centered" };
const _hoisted_4$6 = { class: "content wrap-text" };
const _hoisted_5$6 = { style: { "margin-top": "32px", "margin-bottom": "40px" } };
const _hoisted_6$5 = ["innerHTML"];
const _hoisted_7$5 = { class: "flex flex-row flex-center" };
const _hoisted_8$4 = {
  class: "flex-row",
  style: { "margin-top": "8px" }
};
const _hoisted_9$4 = {
  class: "error-message",
  style: { "min-height": "17px" }
};
const _hoisted_10$2 = {
  class: "flex-row flex-center",
  style: { "margin-top": "16px" }
};
const _hoisted_11$1 = ["onClick", "disabled"];
const _hoisted_12$1 = /* @__PURE__ */ createBaseVNode("div", { class: "spacer" }, null, -1);
const _hoisted_13$1 = { class: "flex-row flex-wrap flex-between" };
const _hoisted_14$1 = { class: "link" };
const _hoisted_15$1 = ["onClick"];
const _hoisted_16$1 = { class: "link" };
const _hoisted_17$1 = ["onClick"];
const numInputs = 6;
const disableInputsOnSendCodeError = false;
const _sfc_main$d = defineComponent({
  __name: "OneTimePasscode",
  props: {
    identifier: {},
    userIsRegistering: { type: Boolean },
    identifierVerifying: { type: Boolean },
    setupNewDevice: { type: Boolean },
    identifierType: {}
  },
  setup(__props) {
    const props = __props;
    const { t, te, locale } = useLocale();
    const loading = ref(true);
    const oneTimePasscode = ref(void 0);
    const errorWithOneTimePasscode = ref(false);
    const errorSendingOneTimePasscode = ref(false);
    const errorMessage = ref(void 0);
    const otpId = ref(void 0);
    const title = computed(() => {
      if (props.identifierVerifying) {
        return t("verify-account");
      }
      return t("enter-code");
    });
    const message = computed(() => {
      return te("enter-code-sent") ? t("enter-code-sent", [props.identifier]) : `A one-time code has been sent to <span style="font-weight: 700;">${props.identifier}</span>. Enter the code here to log in.`;
    });
    const btnGoBackText = computed(() => {
      return te("back") ? t("back") : "Back";
    });
    const btnResendText = computed(() => {
      return te("resend-code") ? t("resend-code") : "Resend code";
    });
    const oneTimePasscodeInputClasses = computed(() => {
      return errorWithOneTimePasscode.value ? ["has-error"] : [];
    });
    const oneTimePasscodeInputsDisabled = computed(() => {
      return disableInputsOnSendCodeError;
    });
    const continueBtnDisabled = computed(() => {
      return loading.value;
    });
    watch(oneTimePasscode, () => {
      var _a;
      _resetErrorState();
      if (((_a = oneTimePasscode.value) == null ? void 0 : _a.trim().length) === numInputs) {
        activateOneTimePasscode();
      }
    });
    const { passage } = usePassage();
    const sendOneTimePasscode = (isRegistering = false) => __async(this, null, function* () {
      _resetLoadingState();
      _resetErrorState();
      _resetOneTimePasscode();
      loading.value = true;
      try {
        const res = isRegistering ? yield passage.newRegisterOneTimePasscode(props.identifier, locale.value.split("-")[0]) : yield passage.newLoginOneTimePasscode(props.identifier, locale.value.split("-")[0]);
        if (res.otp_id != "") {
          localStorage.setItem("otp_id", res.otp_id);
          otpId.value = res.otp_id;
        }
      } catch (err) {
        setError(te("code-send-error") ? t("code-send-error") : "An error occurred sending the code.", true);
      } finally {
        loading.value = false;
      }
    });
    const activateOneTimePasscode = () => __async(this, null, function* () {
      _resetLoadingState();
      _resetErrorState();
      loading.value = true;
      try {
        if (!oneTimePasscode.value) {
          throw new Error("Login code is undefined.");
        }
        if (oneTimePasscode.value.length !== numInputs) {
          throw new Error("Login code is invalid length.");
        }
        if (!otpId.value) {
          throw new Error("Login code id is undefined.");
        }
        const result = yield passage.oneTimePasscodeActivate(oneTimePasscode.value, otpId.value);
        if (result && result.redirect_url != "") {
          localStorage.removeItem("otp_id");
          useCallbacks().onEvent.value(OnEventType.onOneTimePasscodeActivated);
          useAuthEvent().emitEvent({
            type: AuthEventType.EmailOrSMSAuthSuccess,
            payload: {
              identifier: props.identifier,
              authResult: result
            }
          });
        }
      } catch (err) {
        const passageError = err;
        if (passageError.statusCode === R.Unauthorized) {
          setError(t("otp-limit-error"));
        } else {
          setError(t("code-invalid-or-expired"));
        }
      } finally {
        loading.value = false;
      }
    });
    const onGoBackClicked = () => {
      useAuthEvent().emitEvent({ type: AuthEventType.ChangeIdentifier, payload: void 0 });
    };
    const onResendCodeClicked = () => {
      sendOneTimePasscode();
    };
    const onSubmitClicked = () => {
      activateOneTimePasscode();
    };
    onMounted(() => {
      sendOneTimePasscode(props.userIsRegistering);
      moveInput();
    });
    onBeforeUnmount(() => {
      cleanupInput();
    });
    const _resetLoadingState = () => {
      loading.value = true;
    };
    const _resetErrorState = () => {
      errorMessage.value = void 0;
      errorWithOneTimePasscode.value = false;
      errorSendingOneTimePasscode.value = false;
    };
    const _resetOneTimePasscode = () => {
      oneTimePasscode.value = void 0;
    };
    const setError = (message2, sending = false) => {
      errorMessage.value = message2;
      errorWithOneTimePasscode.value = !sending;
      errorSendingOneTimePasscode.value = sending;
    };
    const otpInput = ref();
    function moveInput() {
      const parent = otpInput.value.getRootNode().host;
      otpInput.value.appendChild(otcStyles());
      parent.appendChild(otpInput.value);
    }
    function cleanupInput() {
      otpInput.value.remove();
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$b, [
        createBaseVNode("form", _hoisted_2$7, [
          createBaseVNode("div", _hoisted_3$7, [
            createBaseVNode("span", null, toDisplayString(title.value), 1)
          ]),
          createBaseVNode("div", _hoisted_4$6, [
            createBaseVNode("div", _hoisted_5$6, [
              createBaseVNode("p", { innerHTML: message.value }, null, 8, _hoisted_6$5)
            ])
          ]),
          createBaseVNode("div", _hoisted_7$5, [
            createBaseVNode("div", {
              ref_key: "otpInput",
              ref: otpInput,
              slot: "otpInput"
            }, [
              createVNode(_sfc_main$e, {
                "num-inputs": numInputs,
                "is-disabled": oneTimePasscodeInputsDisabled.value,
                value: oneTimePasscode.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event) => oneTimePasscode.value = $event),
                "input-classes": oneTimePasscodeInputClasses.value,
                "disable-non-current": false
              }, null, 8, ["is-disabled", "value", "input-classes"])
            ], 512),
            renderSlot(_ctx.$slots, "otpInput")
          ]),
          createBaseVNode("div", _hoisted_8$4, [
            createBaseVNode("div", _hoisted_9$4, toDisplayString(errorMessage.value ? errorMessage.value : " "), 1)
          ]),
          createBaseVNode("div", _hoisted_10$2, [
            createBaseVNode("button", {
              type: "submit",
              class: "button is-primary",
              part: "button",
              "data-testid": "continue-button",
              onClick: withModifiers(onSubmitClicked, ["prevent"]),
              disabled: continueBtnDisabled.value
            }, toDisplayString(unref(t)("continue")), 9, _hoisted_11$1)
          ]),
          _hoisted_12$1,
          createBaseVNode("div", _hoisted_13$1, [
            createBaseVNode("div", _hoisted_14$1, [
              createBaseVNode("a", {
                onClick: withModifiers(onGoBackClicked, ["prevent"]),
                role: "button",
                "data-testid": "one-time-passcode-goback-button"
              }, toDisplayString(btnGoBackText.value), 9, _hoisted_15$1)
            ]),
            createBaseVNode("div", _hoisted_16$1, [
              createBaseVNode("a", {
                onClick: withModifiers(onResendCodeClicked, ["prevent"]),
                role: "button",
                "data-testid": "one-time-passcode-resend-button"
              }, toDisplayString(btnResendText.value), 9, _hoisted_17$1)
            ])
          ])
        ])
      ]);
    };
  }
});
const _hoisted_1$a = { class: "view-access-token auth-flex-container" };
const _sfc_main$c = defineComponent({
  __name: "OneTimePasscodeView",
  props: {
    identifier: {},
    userIsRegistering: { type: Boolean },
    identifierVerifying: { type: Boolean },
    setupNewDevice: { type: Boolean },
    identifierType: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$a, [
        createVNode(_sfc_main$d, {
          identifier: _ctx.identifier,
          userIsRegistering: _ctx.userIsRegistering,
          identifierVerifying: _ctx.identifierVerifying,
          setupNewDevice: _ctx.setupNewDevice,
          identifierType: _ctx.identifierType
        }, {
          otpInput: withCtx(() => [
            renderSlot(_ctx.$slots, "otpInput")
          ]),
          _: 3
        }, 8, ["identifier", "userIsRegistering", "identifierVerifying", "setupNewDevice", "identifierType"])
      ]);
    };
  }
});
const _hoisted_1$9 = {
  class: "title has-text-centered secondary-title",
  "data-testid": "activate-magic-link-message"
};
const _hoisted_2$6 = {
  class: "image has-text-centered",
  style: { "margin-bottom": "32px" }
};
const _hoisted_3$6 = {
  key: 0,
  class: "has-text-centered",
  style: { "margin-bottom": "32px" }
};
const _hoisted_4$5 = {
  class: "flex-row flex-center",
  style: { "margin-bottom": "64px" }
};
const _hoisted_5$5 = ["onClick", "disabled"];
const _hoisted_6$4 = { key: 0 };
const _hoisted_7$4 = { key: 1 };
const _hoisted_8$3 = {
  key: 2,
  class: "link has-text-centered"
};
const _hoisted_9$3 = ["onClick"];
const _sfc_main$b = defineComponent({
  __name: "AddDevice",
  props: {
    authResult: {},
    identifier: {}
  },
  setup(__props) {
    const props = __props;
    const { t } = useLocale();
    const showFailure = ref(false);
    const showSuccess = ref(false);
    const newDevice = ref();
    const { addDevice, addPending } = useAddDevice();
    const { autofocusButton } = useAutofocusButton();
    const title = computed(() => {
      if (showFailure.value) {
        return t("something-went-wrong");
      } else {
        return t("add-passkey");
      }
    });
    function onButtonClick() {
      return __async(this, null, function* () {
        var _a;
        newDevice.value = yield addDevice();
        if ((_a = newDevice.value) == null ? void 0 : _a.id) {
          showSuccess.value = true;
          showFailure.value = false;
          finishAuth();
        } else {
          showFailure.value = true;
          showSuccess.value = false;
        }
      });
    }
    const finishAuth = () => {
      useAuthEvent().emitEvent({
        type: AuthEventType.AuthSuccess,
        payload: {
          identifier: props.identifier,
          authResult: props.authResult
        }
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createBaseVNode("div", _hoisted_1$9, toDisplayString(title.value), 1),
        createBaseVNode("figure", _hoisted_2$6, [
          showFailure.value ? (openBlock(), createBlock(unref(InlineSvg), {
            key: 0,
            src: unref(Icons).failure,
            alt: "Device failure"
          }, null, 8, ["src"])) : (openBlock(), createBlock(unref(InlineSvg), {
            key: 1,
            src: unref(Icons).passkey,
            alt: "Add a passkey"
          }, null, 8, ["src"]))
        ]),
        showFailure.value ? (openBlock(), createElementBlock("div", _hoisted_3$6, toDisplayString(unref(t)("failed-to-add-this-device")), 1)) : (openBlock(), createBlock(_sfc_main$k, {
          key: 1,
          cta: unref(t)("log-into-your-account")
        }, null, 8, ["cta"])),
        createBaseVNode("div", _hoisted_4$5, [
          createBaseVNode("button", {
            onClick: withModifiers(onButtonClick, ["prevent"]),
            type: "button",
            class: normalizeClass(["button is-primary", { "is-loading": unref(addPending) }]),
            part: "button",
            disabled: unref(addPending),
            "data-testid": "save-device-button",
            ref_key: "autofocusButton",
            ref: autofocusButton
          }, [
            showFailure.value ? (openBlock(), createElementBlock("span", _hoisted_6$4, toDisplayString(unref(t)("try-again")), 1)) : (openBlock(), createElementBlock("span", _hoisted_7$4, toDisplayString(unref(t)("add-passkey")), 1))
          ], 10, _hoisted_5$5)
        ]),
        !showSuccess.value ? (openBlock(), createElementBlock("div", _hoisted_8$3, [
          createBaseVNode("div", null, [
            createBaseVNode("a", {
              onClick: withModifiers(finishAuth, ["prevent"]),
              role: "button",
              "data-testid": "add-device-skip"
            }, toDisplayString(unref(t)("skip")), 9, _hoisted_9$3)
          ])
        ])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _hoisted_1$8 = { class: "view-add-device" };
const _sfc_main$a = defineComponent({
  __name: "AddDeviceView",
  props: {
    authResult: {},
    identifier: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$8, [
        createVNode(_sfc_main$b, {
          authResult: _ctx.authResult,
          identifier: _ctx.identifier
        }, null, 8, ["authResult", "identifier"])
      ]);
    };
  }
});
const _hoisted_1$7 = {
  class: "wrap-text",
  style: { "margin-bottom": "12px !important" }
};
const _hoisted_2$5 = { class: "passage-learnmore-header" };
const _hoisted_3$5 = { class: "passage-learnmore-body" };
const _hoisted_4$4 = { class: "passage-learnmore-header" };
const _hoisted_5$4 = { class: "passage-learnmore-body" };
const _sfc_main$9 = defineComponent({
  __name: "LearnMoreDisabledFallbacks",
  setup(__props) {
    const { t } = useLocale();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$l, null, {
        cta: withCtx(() => [
          createBaseVNode("div", _hoisted_1$7, toDisplayString(unref(t)("passkeys-are-required")) + toDisplayString(" "), 1),
          createTextVNode(" " + toDisplayString(unref(t)("try-again-on-device-with-passkeys")), 1)
        ]),
        body: withCtx(() => [
          createBaseVNode("div", _hoisted_2$5, toDisplayString(unref(t)("what-are-passkeys")), 1),
          createBaseVNode("div", _hoisted_3$5, toDisplayString(unref(t)("passkeys-are-a-simpler-and-more-secure-alternative")), 1),
          createBaseVNode("div", _hoisted_4$4, toDisplayString(unref(t)("devices-that-support-passkeys")), 1),
          createBaseVNode("div", _hoisted_5$4, toDisplayString(unref(t)("devices-with-a-biometric-sensor-are-likely-to-support-passkeys")), 1)
        ]),
        _: 1
      });
    };
  }
});
const _hoisted_1$6 = { class: "auth-flex-container" };
const _hoisted_2$4 = { class: "title has-text-centered" };
const _hoisted_3$4 = { class: "image has-text-centered" };
const _hoisted_4$3 = /* @__PURE__ */ createBaseVNode("div", { class: "spacer" }, null, -1);
const _hoisted_5$3 = { class: "flex-row flex-wrap flex-center" };
const _hoisted_6$3 = { class: "link" };
const _hoisted_7$3 = ["onClick"];
const _sfc_main$8 = defineComponent({
  __name: "DisableFallbacks",
  setup(__props) {
    const { t } = useLocale();
    const { emitEvent: emitEvent2 } = useAuthEvent();
    function changeEmail() {
      localStorage.removeItem("email");
      emitEvent2({
        type: AuthEventType.ChangeIdentifier,
        payload: void 0
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$6, [
        createBaseVNode("div", _hoisted_2$4, toDisplayString(unref(t)("device-not-supported")), 1),
        createBaseVNode("figure", _hoisted_3$4, [
          createVNode(unref(InlineSvg), {
            src: unref(Icons).passkeyArrow,
            alt: "Device not supported"
          }, null, 8, ["src"])
        ]),
        createVNode(_sfc_main$9),
        _hoisted_4$3,
        createBaseVNode("div", _hoisted_5$3, [
          createBaseVNode("div", _hoisted_6$3, [
            createBaseVNode("a", {
              onClick: withModifiers(changeEmail, ["prevent"]),
              role: "button",
              "data-testid": "change-email-button"
            }, toDisplayString(unref(t)("back")), 9, _hoisted_7$3)
          ])
        ])
      ]);
    };
  }
});
const _sfc_main$7 = defineComponent({
  __name: "DisableFallbackView",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$8);
    };
  }
});
const _hoisted_1$5 = { class: "auth-flex-container" };
const _hoisted_2$3 = { class: "title has-text-centered" };
const _hoisted_3$3 = { class: "image has-text-centered" };
const _hoisted_4$2 = {
  class: "wrap-text",
  style: { "margin-bottom": "12px !important" }
};
const _hoisted_5$2 = { class: "wrap-text" };
const _hoisted_6$2 = /* @__PURE__ */ createBaseVNode("div", { class: "spacer" }, null, -1);
const _hoisted_7$2 = { class: "flex-row flex-wrap flex-center" };
const _hoisted_8$2 = { class: "link" };
const _hoisted_9$2 = ["onClick"];
const _sfc_main$6 = defineComponent({
  __name: "LoginNotSupported",
  setup(__props) {
    const { t } = useLocale();
    const { emitEvent: emitEvent2 } = useAuthEvent();
    function changeEmail() {
      localStorage.removeItem("email");
      emitEvent2({
        type: AuthEventType.ChangeIdentifier,
        payload: void 0
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$5, [
        createBaseVNode("div", _hoisted_2$3, toDisplayString(unref(t)("login-not-supported")), 1),
        createBaseVNode("figure", _hoisted_3$3, [
          createVNode(unref(InlineSvg), {
            src: unref(Icons).passkeyArrow,
            alt: "Device not supported"
          }, null, 8, ["src"])
        ]),
        createBaseVNode("div", _hoisted_4$2, toDisplayString(unref(t)("passkeys-are-now-required")), 1),
        createBaseVNode("div", _hoisted_5$2, toDisplayString(unref(t)("please-contact-support-to-regain-access")), 1),
        _hoisted_6$2,
        createBaseVNode("div", _hoisted_7$2, [
          createBaseVNode("div", _hoisted_8$2, [
            createBaseVNode("a", {
              onClick: withModifiers(changeEmail, ["prevent"]),
              role: "button",
              "data-testid": "change-email-button"
            }, toDisplayString(unref(t)("back")), 9, _hoisted_9$2)
          ])
        ])
      ]);
    };
  }
});
const _sfc_main$5 = defineComponent({
  __name: "LoginNotSupportedView",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$6);
    };
  }
});
const _hoisted_1$4 = { class: "auth-flex-container flex-center" };
const _hoisted_2$2 = { class: "title has-text-centered" };
const _hoisted_3$2 = {
  class: "flex-column flex-center",
  style: { "margin-bottom": "32px" }
};
const _hoisted_4$1 = { key: 2 };
const _hoisted_5$1 = { style: { "margin-bottom": "40px" } };
const _hoisted_6$1 = ["onClick"];
const _hoisted_7$1 = ["onClick"];
const _hoisted_8$1 = /* @__PURE__ */ createBaseVNode("div", { class: "spacer" }, null, -1);
const _hoisted_9$1 = {
  key: 2,
  class: "link has-text-centered"
};
const _hoisted_10$1 = ["onClick"];
const _sfc_main$4 = defineComponent({
  __name: "LinkAccount",
  props: {
    identifier: {},
    code: {}
  },
  setup(__props) {
    const props = __props;
    const { t } = useLocale();
    const { theme } = useTheme();
    const { emitEvent: emitEvent2 } = useAuthEvent();
    const { passage } = usePassage();
    const showError = ref(false);
    const connection = sessionStorage.getItem("oauth2Connection");
    const metadata = socialConnectionMetadata[connection];
    const title = computed(() => {
      if (showError.value) {
        return t("link-account-failed");
      }
      return t("link-your-account-to-social-provider", [t(connection != null ? connection : "")]);
    });
    const buttonIconAlt = computed(() => {
      return `${t(metadata.nameKey)} icon`;
    });
    const message = computed(() => {
      if (showError.value) {
        return t("session-invalid");
      }
      return t("found-existing-account", [t(connection != null ? connection : "")]);
    });
    const icon = computed(() => {
      switch (theme.value) {
        case Theme.Dark:
          return metadata.icons.dark;
        case Theme.Light:
        default:
          return metadata.icons.light;
      }
    });
    function cancel() {
      emitEvent2({ type: AuthEventType.ChangeIdentifier, payload: void 0 });
    }
    function linkAccount() {
      return __async(this, null, function* () {
        try {
          const authResult = yield passage.finishSocialAuthentication(props.code);
          emitEvent2({
            type: AuthEventType.AuthSuccess,
            payload: {
              authResult
            }
          });
        } catch (error) {
          const psgError = error;
          console.error(psgError.message);
          showError.value = true;
        }
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("form", _hoisted_1$4, [
        createBaseVNode("div", _hoisted_2$2, [
          createBaseVNode("span", null, toDisplayString(title.value), 1)
        ]),
        createBaseVNode("div", _hoisted_3$2, [
          !showError.value ? (openBlock(), createBlock(unref(InlineSvg), {
            key: 0,
            class: "link-account-icon",
            src: icon.value,
            alt: buttonIconAlt.value
          }, null, 8, ["src", "alt"])) : (openBlock(), createBlock(unref(InlineSvg), {
            key: 1,
            src: unref(Icons).failure,
            class: "link-account-failed",
            alt: "Account link failure"
          }, null, 8, ["src"])),
          !showError.value ? (openBlock(), createElementBlock("div", _hoisted_4$1, [
            createBaseVNode("strong", null, toDisplayString(_ctx.identifier), 1)
          ])) : createCommentVNode("", true)
        ]),
        createBaseVNode("div", _hoisted_5$1, toDisplayString(message.value), 1),
        !showError.value ? (openBlock(), createElementBlock("button", {
          key: 0,
          class: "button is-primary",
          onClick: withModifiers(linkAccount, ["prevent"])
        }, toDisplayString(unref(t)("link-account")), 9, _hoisted_6$1)) : (openBlock(), createElementBlock("button", {
          key: 1,
          class: "button is-primary",
          onClick: withModifiers(cancel, ["prevent"])
        }, toDisplayString(unref(t)("return-to-login")), 9, _hoisted_7$1)),
        _hoisted_8$1,
        !showError.value ? (openBlock(), createElementBlock("div", _hoisted_9$1, [
          createBaseVNode("a", {
            onClick: withModifiers(cancel, ["prevent"]),
            role: "button"
          }, toDisplayString(unref(t)("cancel")), 9, _hoisted_10$1)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const _hoisted_1$3 = { class: "link-account auth-flex-container" };
const _sfc_main$3 = defineComponent({
  __name: "LinkAccountView",
  props: {
    identifier: {},
    code: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$3, [
        createVNode(_sfc_main$4, {
          identifier: _ctx.identifier,
          code: _ctx.code
        }, null, 8, ["identifier", "code"])
      ]);
    };
  }
});
const AuthRoute = {
  component: _sfc_main$t
};
const LoginRoute = {
  component: _sfc_main$q
};
const RegisterRoute = {
  component: _sfc_main$p
};
const RegisterDeviceRoute = {
  component: _sfc_main$i
};
const MagicLinkRoute = {
  component: _sfc_main$m
};
const WebauthnSignInRoute = {
  component: _sfc_main$g
};
const ActivateMagicLinkRoute = {
  component: _sfc_main$r
};
const OneTimePasscodeRoute = {
  component: _sfc_main$c
};
const AddDeviceRoute = {
  component: _sfc_main$a
};
const DisableFallbacksRoute = {
  component: _sfc_main$7
};
const LoginNotSupportedRoute = {
  component: _sfc_main$5
};
const LinkAccountRoute = {
  component: _sfc_main$3
};
const ELEMENT_CUSTOMIZATION_FIELD_TO_CSS_VAR_NAME = {
  passage_container_background_color: "--passage-container-background-color-default",
  passage_container_max_width: "--passage-container-max-width-default",
  passage_input_box_background_color: "--passage-input-box-background-color-default",
  passage_input_box_border_radius: "--passage-input-box-border-radius-default",
  passage_header_font_family: "--passage-header-font-family-default",
  passage_body_font_family: "--passage-body-font-family-default",
  passage_header_text_color: "--passage-header-text-color-default",
  passage_body_text_color: "--passage-body-text-color-default",
  passage_primary_button_background_color: "--passage-primary-button-background-color-default",
  passage_primary_button_text_color: "--passage-primary-button-text-color-default",
  passage_primary_button_hover_color: "--passage-primary-button-background-hover-color-default",
  passage_primary_button_border_radius: "--passage-primary-button-border-radius-default",
  passage_primary_button_border_color: "--passage-primary-button-border-color-default",
  passage_primary_button_border_width: "--passage-primary-button-border-width-default",
  passage_secondary_button_background_color: "--passage-secondary-button-background-color-default",
  passage_secondary_button_text_color: "-passage-secondary-button-text-color-default",
  passage_secondary_button_hover_color: "--passage-secondary-button-background-hover-color-default",
  passage_secondary_button_border_radius: "--passage-secondary-button-border-radius-default",
  passage_secondary_button_border_color: "--passage-secondary-button-border-color-default",
  passage_secondary_button_border_width: "--passage-secondary-button-border-width-default"
};
const PIXEL_ELEMENT_CUSTOMIZATION_FIELDS = {
  passage_container_max_width: "passage_container_max_width",
  passage_input_box_border_radius: "passage_input_box_border_radius",
  passage_primary_button_border_radius: "passage_primary_button_border_radius",
  passage_primary_button_border_width: "passage_primary_button_border_width",
  passage_secondary_button_border_radius: "passage_secondary_button_border_radius",
  passage_secondary_button_border_width: "passage_secondary_button_border_width"
};
function transformToPixelString(cssValue) {
  return `${cssValue}px`;
}
function useElementCustomization() {
  const setCustomElementStyles = (authContainerRef, appInfo, theme) => {
    const styleSet = theme === Theme.Light ? appInfo.element_customization : appInfo.element_customization_dark;
    Object.entries(styleSet).forEach((entry) => {
      const [cssAttribute, cssValue] = entry;
      let transformedCssValue = cssValue;
      if (Object.values(PIXEL_ELEMENT_CUSTOMIZATION_FIELDS).includes(cssAttribute)) {
        transformedCssValue = transformToPixelString(cssValue);
      }
      authContainerRef.style.setProperty(
        ELEMENT_CUSTOMIZATION_FIELD_TO_CSS_VAR_NAME[cssAttribute],
        transformedCssValue
      );
    });
  };
  return {
    setCustomElementStyles
  };
}
class Router {
  constructor(homeRoute) {
    this._homeRoute = AuthRoute;
    this._history = [];
    if (homeRoute !== void 0) {
      this._homeRoute = homeRoute;
    }
  }
  get homeRoute() {
    return this._homeRoute;
  }
  set homeRoute(homeRoute) {
    this._homeRoute = homeRoute;
  }
  get currentRoute() {
    if (this._history.length === 0) {
      return void 0;
    }
    return this._history[this._history.length - 1];
  }
  push(route, props) {
    this._history.push(__spreadProps(__spreadValues({}, route), { props }));
  }
  resetRouter() {
    this._history = [];
  }
}
const _hoisted_1$2 = { class: "debug-router" };
const _hoisted_2$1 = /* @__PURE__ */ createBaseVNode("div", { class: "section-label" }, "View", -1);
const _hoisted_3$1 = /* @__PURE__ */ createBaseVNode("div", { class: "section-label" }, "Props", -1);
const _hoisted_4 = { key: 0 };
const _hoisted_5 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Identifier", -1);
const _hoisted_6 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Identifier Type", -1);
const _hoisted_7 = { key: 1 };
const _hoisted_8 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Identifier", -1);
const _hoisted_9 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Identifier Type", -1);
const _hoisted_10 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "User Is Verifying", -1);
const _hoisted_11 = { key: 2 };
const _hoisted_12 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Identifier", -1);
const _hoisted_13 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Identifier Type", -1);
const _hoisted_14 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Setup New Device", -1);
const _hoisted_15 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "User Is Registering", -1);
const _hoisted_16 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Verifying Identifier", -1);
const _hoisted_17 = { key: 3 };
const _hoisted_18 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Identifier", -1);
const _hoisted_19 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Identifier Type", -1);
const _hoisted_20 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Setup New Device", -1);
const _hoisted_21 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "User Is Registering", -1);
const _hoisted_22 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Verifying Identifier", -1);
const _hoisted_23 = { key: 4 };
const _hoisted_24 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Identifier", -1);
const _hoisted_25 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Social Connection", -1);
const _hoisted_26 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Code", -1);
const _hoisted_27 = { key: 5 };
const _hoisted_28 = /* @__PURE__ */ createBaseVNode("div", { class: "control-label" }, "Magic Link", -1);
const _hoisted_29 = { key: 6 };
const _hoisted_30 = ["onClick"];
const identifier = `authenticator@passage.id`;
const _sfc_main$2 = defineComponent({
  __name: "DebugRouter",
  props: {
    router: {},
    appInfo: {}
  },
  setup(__props) {
    const props = __props;
    const views = ref([
      {
        name: "Main View",
        value: {
          route: props.router.homeRoute,
          key: "MAINVIEW"
        }
      },
      {
        name: "Register Device",
        value: {
          route: RegisterDeviceRoute,
          key: "REGISTERDEVICE"
        }
      },
      {
        name: "Webauthnn Login",
        value: {
          route: WebauthnSignInRoute,
          key: "WEBAUTHNSIGNIN"
        }
      },
      {
        name: "One Time Passcode",
        value: {
          route: OneTimePasscodeRoute,
          key: "OTP"
        }
      },
      {
        name: "Magic Link",
        value: {
          route: MagicLinkRoute,
          key: "MAGICLINK"
        }
      },
      {
        name: "Activate Magic Link",
        value: {
          route: ActivateMagicLinkRoute,
          key: "ACTIVATEMAGICLINK"
        }
      },
      {
        name: "Add Device",
        value: {
          route: AddDeviceRoute,
          key: "ADDDEVICE"
        }
      },
      {
        name: "Device Not Supported",
        value: {
          route: DisableFallbacksRoute,
          key: "DEVICENOTSUPPORTED"
        }
      },
      {
        name: "Login Not Supported",
        value: {
          route: LoginNotSupportedRoute,
          key: "LOGINNOTSUPPORTED"
        }
      },
      {
        name: "Link Account",
        value: {
          route: LinkAccountRoute,
          key: "LINKACCOUNT"
        }
      }
    ]);
    const selectedRoute = ref(views.value[0].value);
    const passkeyFeatures = {
      securityKey: true,
      platform: true,
      syncedCredential: true,
      crossDeviceCredential: true,
      conditionalUI: true,
      isAvailable: true
    };
    const { passage } = usePassage();
    passage.getCredentialAvailable().then((passkeyFeatures2) => registerDeviceProps.passkeyFeatures = passkeyFeatures2);
    passage.getCurrentSession().getAuthToken().then((authToken) => {
      addDeviceProps.authResult.auth_token = authToken;
    }).catch(() => {
    });
    const identifierTypes = [
      {
        name: "Email",
        value: IdentifierType.email
      },
      {
        name: "Phone",
        value: IdentifierType.phone
      }
    ];
    const mainViewProps = reactive({
      register: false,
      appInfo: props.appInfo
    });
    const registerDeviceProps = reactive({
      identifier,
      identifierType: IdentifierType.email,
      appInfo: props.appInfo,
      passkeyFeatures
    });
    const webauthnSignInProps = reactive({
      identifier,
      identifierType: IdentifierType.email,
      appInfo: props.appInfo,
      userIsVerifying: false
    });
    const otpProps = reactive({
      identifier,
      identifierType: IdentifierType.email,
      setupNewDevice: false,
      userIsRegistering: false,
      identifierVerifying: false
    });
    const magicLinkProps = reactive({
      identifier,
      identifierType: IdentifierType.email,
      setupNewDevice: false,
      userIsRegistering: false,
      identifierVerifying: false
    });
    const activateMagicLinkProps = reactive({
      magicLink: "",
      webauthnAllowed: true
    });
    const addDeviceProps = reactive({
      authResult: {
        redirect_url: props.appInfo.redirect_url,
        auth_token: ""
      }
    });
    const linkAccountProps = reactive({
      identifier,
      code: "1234"
    });
    const linkAccountConnection = ref(me.Google);
    const socialConnections = [
      {
        name: "Google",
        value: me.Google
      },
      {
        name: "Github",
        value: me.Github
      },
      {
        name: "Apple",
        value: me.Apple
      }
    ];
    function goToView() {
      let viewProps = void 0;
      switch (selectedRoute.value.key) {
        case "MAINVIEW":
          viewProps = mainViewProps;
          break;
        case "REGISTERDEVICE":
          viewProps = registerDeviceProps;
          break;
        case "WEBAUTHNSIGNIN":
          viewProps = webauthnSignInProps;
          break;
        case "OTP":
          viewProps = otpProps;
          break;
        case "MAGICLINK":
          viewProps = magicLinkProps;
          break;
        case "ACTIVATEMAGICLINK":
          viewProps = activateMagicLinkProps;
          break;
        case "ADDDEVICE":
          viewProps = addDeviceProps;
          break;
        case "LINKACCOUNT":
          viewProps = linkAccountProps;
          sessionStorage.setItem("oauth2Connection", linkAccountConnection.value);
          break;
        case "DEVICENOTSUPPORTED":
        case "LOGINNOTSUPPORTED":
          viewProps = void 0;
          break;
      }
      props.router.push(selectedRoute.value.route, viewProps);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$2, [
        _hoisted_2$1,
        createVNode(Dropdown, {
          modelValue: selectedRoute.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selectedRoute.value = $event),
          items: views.value
        }, null, 8, ["modelValue", "items"]),
        _hoisted_3$1,
        selectedRoute.value.key === "REGISTERDEVICE" ? (openBlock(), createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => registerDeviceProps.identifier = $event),
            type: "text",
            class: "input psg-input"
          }, null, 512), [
            [vModelText, registerDeviceProps.identifier]
          ]),
          _hoisted_6,
          createVNode(Dropdown, {
            modelValue: registerDeviceProps.identifierType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => registerDeviceProps.identifierType = $event),
            items: identifierTypes
          }, null, 8, ["modelValue"])
        ])) : selectedRoute.value.key === "WEBAUTHNSIGNIN" ? (openBlock(), createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => webauthnSignInProps.identifier = $event),
            type: "text",
            class: "input psg-input"
          }, null, 512), [
            [vModelText, webauthnSignInProps.identifier]
          ]),
          _hoisted_9,
          createVNode(Dropdown, {
            modelValue: webauthnSignInProps.identifierType,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => webauthnSignInProps.identifierType = $event),
            items: identifierTypes
          }, null, 8, ["modelValue"]),
          _hoisted_10,
          createVNode(Checkbox, {
            modelValue: webauthnSignInProps.userIsVerifying,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => webauthnSignInProps.userIsVerifying = $event)
          }, null, 8, ["modelValue"])
        ])) : selectedRoute.value.key === "OTP" ? (openBlock(), createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => otpProps.identifier = $event),
            type: "text",
            class: "input psg-input"
          }, null, 512), [
            [vModelText, otpProps.identifier]
          ]),
          _hoisted_13,
          createVNode(Dropdown, {
            modelValue: otpProps.identifierType,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => otpProps.identifierType = $event),
            items: identifierTypes
          }, null, 8, ["modelValue"]),
          _hoisted_14,
          createVNode(Checkbox, {
            modelValue: otpProps.setupNewDevice,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => otpProps.setupNewDevice = $event)
          }, null, 8, ["modelValue"]),
          _hoisted_15,
          createVNode(Checkbox, {
            modelValue: otpProps.userIsRegistering,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => otpProps.userIsRegistering = $event)
          }, null, 8, ["modelValue"]),
          _hoisted_16,
          createVNode(Checkbox, {
            modelValue: otpProps.identifierVerifying,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => otpProps.identifierVerifying = $event)
          }, null, 8, ["modelValue"])
        ])) : selectedRoute.value.key === "MAGICLINK" ? (openBlock(), createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => magicLinkProps.identifier = $event),
            type: "text",
            class: "input psg-input"
          }, null, 512), [
            [vModelText, magicLinkProps.identifier]
          ]),
          _hoisted_19,
          createVNode(Dropdown, {
            modelValue: magicLinkProps.identifierType,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => magicLinkProps.identifierType = $event),
            items: identifierTypes
          }, null, 8, ["modelValue"]),
          _hoisted_20,
          createVNode(Checkbox, {
            modelValue: magicLinkProps.setupNewDevice,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => magicLinkProps.setupNewDevice = $event)
          }, null, 8, ["modelValue"]),
          _hoisted_21,
          createVNode(Checkbox, {
            modelValue: magicLinkProps.userIsRegistering,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => magicLinkProps.userIsRegistering = $event)
          }, null, 8, ["modelValue"]),
          _hoisted_22,
          createVNode(Checkbox, {
            modelValue: magicLinkProps.identifierVerifying,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => magicLinkProps.identifierVerifying = $event)
          }, null, 8, ["modelValue"])
        ])) : selectedRoute.value.key === "LINKACCOUNT" ? (openBlock(), createElementBlock("div", _hoisted_23, [
          _hoisted_24,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => linkAccountProps.identifier = $event),
            type: "text",
            class: "input psg-input"
          }, null, 512), [
            [vModelText, linkAccountProps.identifier]
          ]),
          _hoisted_25,
          createVNode(Dropdown, {
            modelValue: linkAccountConnection.value,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => linkAccountConnection.value = $event),
            items: socialConnections
          }, null, 8, ["modelValue"]),
          _hoisted_26,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => linkAccountProps.code = $event),
            type: "text",
            class: "input psg-input"
          }, null, 512), [
            [vModelText, linkAccountProps.code]
          ])
        ])) : selectedRoute.value.key === "ACTIVATEMAGICLINK" ? (openBlock(), createElementBlock("div", _hoisted_27, [
          _hoisted_28,
          withDirectives(createBaseVNode("input", {
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => activateMagicLinkProps.magicLink = $event),
            type: "text",
            class: "input psg-input"
          }, null, 512), [
            [vModelText, activateMagicLinkProps.magicLink]
          ])
        ])) : (openBlock(), createElementBlock("div", _hoisted_29, "None")),
        createBaseVNode("button", {
          class: "button",
          onClick: withModifiers(goToView, ["prevent"]),
          style: { "margin-top": "16px" }
        }, "Go To View", 8, _hoisted_30)
      ]);
    };
  }
});
const _hoisted_1$1 = /* @__PURE__ */ createBaseVNode("div", { class: "header-title" }, "Passage Element Debug", -1);
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "debug-panel-body" };
const _sfc_main$1 = defineComponent({
  __name: "DebugPanel",
  props: {
    router: {},
    appInfo: {}
  },
  setup(__props) {
    const debugBuild = false;
    const debugPanel = ref();
    const panelVisible = ref(false);
    function closeDebugPanel() {
      panelVisible.value = false;
    }
    let pos1 = 0;
    let pos2 = 0;
    let pos3 = 0;
    let pos4 = 0;
    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }
    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      if (debugPanel.value) {
        debugPanel.value.style.top = debugPanel.value.offsetTop - pos2 + "px";
        debugPanel.value.style.left = debugPanel.value.offsetLeft - pos1 + "px";
      }
    }
    function closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    }
    return (_ctx, _cache) => {
      return debugBuild && panelVisible.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "debug-panel",
        ref_key: "debugPanel",
        ref: debugPanel
      }, [
        createBaseVNode("div", {
          class: "debug-panel-header",
          onMousedown: dragMouseDown
        }, [
          _hoisted_1$1,
          createBaseVNode("div", {
            class: "panel-close",
            onClick: withModifiers(closeDebugPanel, ["prevent"])
          }, "\xD7", 8, _hoisted_2)
        ], 32),
        createBaseVNode("div", _hoisted_3, [
          createVNode(_sfc_main$2, {
            "app-info": _ctx.appInfo,
            router: _ctx.router
          }, null, 8, ["app-info", "router"])
        ])
      ], 512)) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1 = {
  key: 1,
  class: "notification is-danger has-text-centered",
  "data-testid": "invalid-app-id"
};
const _sfc_main = defineComponent({
  __name: "SmartRouter",
  props: {
    homeRoute: {},
    authContainerRef: {},
    theme: {}
  },
  setup(__props) {
    const props = __props;
    const router = reactive(new Router(props.homeRoute));
    const currentRoute = computed(() => router.currentRoute);
    const { t } = useLocale();
    const { appInfo, loading, invalidAppId, passage } = useAppInfo();
    const { initEventHandler: initEventHandler2 } = useAuthEvent();
    const { setCustomElementStyles } = useElementCustomization();
    const currentComponent = computed(() => {
      var _a;
      return (_a = currentRoute.value) == null ? void 0 : _a.component;
    });
    const currentProps = computed(() => {
      var _a;
      const props2 = (_a = currentRoute.value) == null ? void 0 : _a.props;
      if (props2 === void 0) {
        return {};
      }
      return props2;
    });
    const initialized = ref(false);
    watch(appInfo, () => __async(this, null, function* () {
      initialized.value = false;
      if (appInfo.value === void 0 || passage.value === void 0) {
        return;
      }
      yield initEventHandler2(appInfo.value, router, passage.value);
      initialized.value = true;
      if (props.authContainerRef) {
        setCustomElementStyles(props.authContainerRef, appInfo.value, props.theme);
      }
    }));
    onUpdated(() => {
      if (appInfo.value === void 0 || props.authContainerRef === null) {
        return;
      }
      setCustomElementStyles(props.authContainerRef, appInfo.value, props.theme);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(Transition, {
          name: "fade",
          mode: "out-in",
          appear: ""
        }, {
          default: withCtx(() => [
            !unref(loading) && initialized.value ? (openBlock(), createBlock(resolveDynamicComponent(currentComponent.value), normalizeProps(mergeProps({ key: 0 }, currentProps.value)), {
              otpInput: withCtx(() => [
                renderSlot(_ctx.$slots, "otpInput")
              ]),
              loginInput: withCtx(() => [
                renderSlot(_ctx.$slots, "loginInput")
              ]),
              _: 3
            }, 16)) : createCommentVNode("", true)
          ]),
          _: 3
        }),
        unref(appInfo) && initialized.value ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          router,
          "app-info": unref(appInfo)
        }, null, 8, ["router", "app-info"])) : createCommentVNode("", true),
        unref(invalidAppId) ? (openBlock(), createElementBlock("div", _hoisted_1, toDisplayString(unref(t)("invalid-app-id")), 1)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
function useElementSetup(props) {
  function storeProps() {
    if (props.appId) {
      createPassageInstance(props.appId, props.tokenStore);
    }
    const { updateDefaultCountryCode } = useDefaultCountryCode();
    updateDefaultCountryCode(props.defaultCountryCode);
    const { setBeforeAuth: setBeforeAuth2, setOnSuccess: setOnSuccess2, setOnEvent: setOnEvent2 } = useCallbacks();
    setBeforeAuth2(props.beforeAuth);
    setOnSuccess2(props.onSuccess);
    setOnEvent2(props.onEvent);
  }
  storeProps();
  onBeforeUpdate(() => {
    storeProps();
  });
  const { languageLoading } = useStoreLocale(props);
  const { currentTheme } = useThemeSetup(props);
  const containerRef = ref();
  useIntlTelInput(containerRef);
  return {
    languageLoading,
    containerRef,
    currentTheme
  };
}
export { AuthRoute as A, LoginRoute as L, RegisterRoute as R, _sfc_main as _, useElementSetup as u };
//# 
